// routes.js - Configuration for all calculator routes
 
export const calculatorRoutes = [
  //Basic Math
  {
  path: "/AdditionCalculator",
  component: "AdditionCalculator",
  folder: "BasicMath",
  title: "Addition Calculator - Add Numbers Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Addition Calculator to add two or more numbers quickly and accurately. Perform basic arithmetic addition operations online.",
  keywords: "addition calculator, add numbers, sum calculator, basic math calculator, arithmetic calculator, online addition"
},
{
  path: "/SubtractionCalculator",
  component: "SubtractionCalculator",
  folder: "BasicMath",
  title: "Subtraction Calculator - Subtract Numbers Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Subtraction Calculator to subtract numbers and find differences. Perform basic arithmetic subtraction operations online.",
  keywords: "subtraction calculator, subtract numbers, difference calculator, basic math, arithmetic calculator, online subtraction"
},
{
  path: "/MultiplicationCalculator",
  component: "MultiplicationCalculator",
  folder: "BasicMath",
  title: "Multiplication Calculator - Multiply Numbers Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Multiplication Calculator to multiply two or more numbers. Perform basic arithmetic multiplication operations online.",
  keywords: "multiplication calculator, multiply numbers, product calculator, basic math calculator, arithmetic calculator, online multiplication"
},
{
  path: "/DivisionCalculator",
  component: "DivisionCalculator",
  folder: "BasicMath",
  title: "Division Calculator - Divide Numbers Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Division Calculator to divide numbers and find quotients. Perform basic arithmetic division operations online.",
  keywords: "division calculator, divide numbers, quotient calculator, basic math calculator, arithmetic calculator, online division"
},
{
  path: "/PercentageCalculator",
  component: "PercentageCalculator",
  folder: "BasicMath",
  title: "Percentage Calculator - Calculate Percentages Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Percentage Calculator to calculate percentages, percentage increase/decrease, and percentage of numbers.",
  keywords: "percentage calculator, percent calculator, percentage increase, percentage decrease, calculate percentage, online percentage tool"
},
{
  path: "/RoundingCalculator",
  component: "RoundingCalculator",
  folder: "BasicMath",
  title: "Rounding Calculator - Round Numbers Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Rounding Calculator to round numbers to nearest whole number, decimal places, or significant figures.",
  keywords: "rounding calculator, round numbers, decimal rounding, nearest whole number, significant figures, number rounding tool"
},
{
  path: "/AverageCalculator",
  component: "AverageCalculator",
  folder: "BasicMath",
  title: "Average Calculator - Calculate Mean Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Average Calculator to calculate mean, median, and mode of number sets. Find statistical averages quickly.",
  keywords: "average calculator, mean calculator, median calculator, mode calculator, statistical average, math calculator"
},
{
  path: "/FractionSimplifier",
  component: "FractionSimplifier",
  folder: "BasicMath",
  title: "Fraction Simplifier - Simplify Fractions Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Fraction Simplifier to reduce fractions to their simplest form. Simplify proper and improper fractions instantly.",
  keywords: "fraction simplifier, simplify fractions, reduce fractions, fraction reducer, math calculator, online fraction tool"
},
{
  path: "/MixedFractionCalculator",
  component: "MixedFractionCalculator",
  folder: "BasicMath",
  title: "Mixed Fraction Calculator - Convert & Calculate Mixed Fractions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Mixed Fraction Calculator to convert between mixed numbers and improper fractions. Perform operations with mixed fractions.",
  keywords: "mixed fraction calculator, mixed number calculator, improper fraction converter, fraction calculator, math tool, online calculator"
},
{
  path: "/RatioCalculator",
  component: "RatioCalculator",
  folder: "BasicMath",
  title: "Ratio Calculator - Calculate Ratios Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Ratio Calculator to calculate, simplify, and compare ratios. Solve ratio and proportion problems easily.",
  keywords: "ratio calculator, simplify ratios, calculate ratios, proportion calculator, math ratio tool, online ratio solver"
},
{
  path: "/ProportionCalculator",
  component: "ProportionCalculator",
  folder: "BasicMath",
  title: "Proportion Calculator - Solve Proportions Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Proportion Calculator to solve proportions and find missing values in proportional relationships.",
  keywords: "proportion calculator, solve proportions, cross multiplication, proportional relationships, math calculator, online proportion solver"
},
{
  path: "/NumberSequenceGenerator",
  component: "NumberSequenceGenerator",
  folder: "BasicMath",
  title: "Number Sequence Generator - Generate Number Patterns | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Number Sequence Generator to create arithmetic, geometric, and custom number sequences and patterns.",
  keywords: "number sequence generator, pattern generator, arithmetic sequence, geometric sequence, number patterns, math generator"
},
{
  path: "/LCMCalculator",
  component: "LCMCalculator",
  folder: "BasicMath",
  title: "LCM Calculator - Find Least Common Multiple | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's LCM Calculator to find the Least Common Multiple of two or more numbers quickly and accurately.",
  keywords: "LCM calculator, least common multiple, find LCM, multiple calculator, math calculator, online LCM tool"
},
{
  path: "/HCFCalculator",
  component: "HCFCalculator",
  folder: "BasicMath",
  title: "HCF Calculator - Find Highest Common Factor | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's HCF Calculator to find the Highest Common Factor (Greatest Common Divisor) of two or more numbers.",
  keywords: "HCF calculator, highest common factor, GCF calculator, greatest common divisor, math calculator, online HCF tool"
},
{
  path: "/PrimeNumberChecker",
  component: "PrimeNumberChecker",
  folder: "BasicMath",
  title: "Prime Number Checker - Check if Number is Prime | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Prime Number Checker to determine if a number is prime or composite. Test numbers for primality instantly.",
  keywords: "prime number checker, is prime checker, prime tester, composite number checker, math tool, online prime checker"
},
{
  path: "/PrimeFactorization",
  component: "PrimeFactorization",
  folder: "BasicMath",
  title: "Prime Factorization Calculator - Factor Numbers into Primes | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Prime Factorization Calculator to break down numbers into their prime factors. Find prime factor trees easily.",
  keywords: "prime factorization calculator, factor calculator, prime factors, factor tree, math calculator, online factorization tool"
},
{
  path: "/ExponentsCalculator",
  component: "ExponentsCalculator",
  folder: "BasicMath",
  title: "Exponents Calculator - Calculate Powers & Exponents | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Exponents Calculator to calculate powers, exponents, and exponential expressions. Solve exponent problems online.",
  keywords: "exponents calculator, power calculator, exponent calculator, exponential calculator, math calculator, online exponent tool"
},
{
  path: "/RootCalculator",
  component: "RootCalculator",
  folder: "BasicMath",
  title: "Root Calculator - Calculate Square Roots Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Root Calculator to calculate square roots, cube roots, and nth roots of numbers. Find roots accurately.",
  keywords: "root calculator, square root calculator, cube root calculator, nth root calculator, math calculator, online root tool"
},
{
  path: "/ScientificNotationConverter",
  component: "ScientificNotationConverter",
  folder: "BasicMath",
  title: "Scientific Notation Converter - Convert to Scientific Notation | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Scientific Notation Converter to convert numbers to and from scientific notation. Handle large and small numbers easily.",
  keywords: "scientific notation converter, convert scientific notation, standard form converter, math converter, online notation tool"
},
{
  path: "/SignificantFiguresCalculator",
  component: "SignificantFiguresCalculator",
  folder: "BasicMath",
  title: "Significant Figures Calculator - Calculate Sig Figs | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Significant Figures Calculator to determine significant figures in numbers and perform sig fig calculations.",
  keywords: "significant figures calculator, sig fig calculator, significant digits, precision calculator, math calculator, online sig fig tool"
},
{
  path: "/AbsoluteValueCalculator",
  component: "AbsoluteValueCalculator",
  folder: "BasicMath",
  title: "Absolute Value Calculator - Find Absolute Values | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Absolute Value Calculator to find the absolute value (modulus) of numbers. Calculate distance from zero.",
  keywords: "absolute value calculator, modulus calculator, distance from zero, math calculator, online absolute value tool"
},
{
  path: "/RandomNumberGenerator",
  component: "RandomNumberGenerator",
  folder: "BasicMath",
  title: "Random Number Generator - Generate Random Numbers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Random Number Generator to generate random numbers within specified ranges. Perfect for games and simulations.",
  keywords: "random number generator, random number picker, randomizer, number generator, online random tool, probability tool"
},
{
  path: "/SumOfSeriesCalculator",
  component: "SumOfSeriesCalculator",
  folder: "BasicMath",
  title: "Sum of Series Calculator - Calculate Series Summation | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Sum of Series Calculator to calculate the sum of arithmetic and geometric series. Solve series problems online.",
  keywords: "sum of series calculator, series calculator, summation calculator, arithmetic series, geometric series, math calculator"
},
{
  path: "/IntegerCalculator",
  component: "IntegerCalculator",
  folder: "BasicMath",
  title: "Integer Calculator - Perform Integer Operations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Integer Calculator to perform operations with integers including addition, subtraction, multiplication, and division.",
  keywords: "integer calculator, whole number calculator, integer operations, math calculator, online integer tool, arithmetic with integers"
},
{
  path: "/NumberComparator",
  component: "NumberComparator",
  folder: "BasicMath",
  title: "Number Comparator - Compare Numbers Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Number Comparator to compare two or more numbers and determine greater than, less than, or equal relationships.",
  keywords: "number comparator, compare numbers, greater than less than, number comparison, math tool, online comparator"
},
{
  path: "/EvenOddChecker",
  component: "EvenOddChecker",
  folder: "BasicMath",
  title: "Even Odd Checker - Check if Number is Even or Odd | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Even Odd Checker to determine if numbers are even or odd. Test integers for parity instantly.",
  keywords: "even odd checker, parity checker, even number checker, odd number checker, math tool, online checker"
},
{
  path: "/CubeRootCalculator",
  component: "CubeRootCalculator",
  folder: "BasicMath",
  title: "Cube Root Calculator - Calculate Cube Roots | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cube Root Calculator to calculate cube roots of numbers. Find perfect cubes and cube root values.",
  keywords: "cube root calculator, cubic root calculator, cube root finder, math calculator, online cube root tool"
},
{
  path: "/NthRootCalculator",
  component: "NthRootCalculator",
  folder: "BasicMath",
  title: "Nth Root Calculator - Calculate Any Root | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Nth Root Calculator to calculate any root (nth root) of numbers. Find radicals and root values easily.",
  keywords: "nth root calculator, radical calculator, root calculator, math calculator, online root tool, radical expressions"
},
{
  path: "/AntilogCalculator",
  component: "AntilogCalculator",
  folder: "BasicMath",
  title: "Antilog Calculator - Calculate Antilogarithms | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Antilog Calculator to calculate antilogarithms (inverse logarithms). Find antilog values for any base.",
  keywords: "antilog calculator, antilogarithm calculator, inverse logarithm, log calculator, math calculator, online antilog tool"
},
{
  path: "/RadicalSimplifier",
  component: "RadicalSimplifier",
  folder: "BasicMath",
  title: "Radical Simplifier - Simplify Radical Expressions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Radical Simplifier to simplify radical expressions, square roots, and other radical forms. Reduce radicals to simplest form.",
  keywords: "radical simplifier, simplify radicals, square root simplifier, radical expressions, math calculator, online radical tool"
},


//Geometry
{
  path: "/AreaCircle",
  component: "AreaCircle",
  folder: "Geometry",
  title: "Circle Area Calculator - Calculate Area of a Circle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Circle Area Calculator to calculate the area of a circle from radius, diameter, or circumference. Quick and accurate results.",
  keywords: "circle area calculator, area of a circle, circle calculator, geometry calculator, math tool, area calculator"
},
{
  path: "/AreaTriangle",
  component: "AreaTriangle",
  folder: "Geometry",
  title: "Triangle Area Calculator - Calculate Area of Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Triangle Area Calculator to calculate the area of triangles using base-height formula or Heron's formula.",
  keywords: "triangle area calculator, area of triangle, geometry calculator, triangle calculator, math tool, area formula"
},
{
  path: "/AreaSquare",
  component: "AreaSquare",
  folder: "Geometry",
  title: "Square Area Calculator - Calculate Area of Square | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Square Area Calculator to calculate the area of a square from side length or diagonal. Simple and accurate.",
  keywords: "square area calculator, area of square, geometry calculator, square calculator, math tool, area formula"
},
{
  path: "/AreaRectangle",
  component: "AreaRectangle",
  folder: "Geometry",
  title: "Rectangle Area Calculator - Calculate Area of Rectangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Rectangle Area Calculator to calculate the area of a rectangle from length and width. Fast and reliable.",
  keywords: "rectangle area calculator, area of rectangle, geometry calculator, rectangle calculator, math tool, area formula"
},
{
  path: "/AreaParallelogram",
  component: "AreaParallelogram",
  folder: "Geometry",
  title: "Parallelogram Area Calculator - Calculate Area of Parallelogram | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Parallelogram Area Calculator to calculate the area of a parallelogram from base and height or sides and angle.",
  keywords: "parallelogram area calculator, area of parallelogram, geometry calculator, parallelogram calculator, math tool, area formula"
},
{
  path: "/AreaTrapezium",
  component: "AreaTrapezium",
  folder: "Geometry",
  title: "Trapezium Area Calculator - Calculate Area of Trapezoid | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Trapezium Area Calculator to calculate the area of a trapezium/trapezoid from bases and height or sides.",
  keywords: "trapezium area calculator, area of trapezoid, trapezoid calculator, geometry calculator, math tool, area formula"
},
{
  path: "/AreaRhombus",
  component: "AreaRhombus",
  folder: "Geometry",
  title: "Rhombus Area Calculator - Calculate Area of Rhombus | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Rhombus Area Calculator to calculate the area of a rhombus from diagonals, side and angle, or base and height.",
  keywords: "rhombus area calculator, area of rhombus, geometry calculator, rhombus calculator, math tool, area formula"
},
{
  path: "/AreaEllipse",
  component: "AreaEllipse",
  folder: "Geometry",
  title: "Ellipse Area Calculator - Calculate Area of Ellipse | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Ellipse Area Calculator to calculate the area of an ellipse from semi-major and semi-minor axes.",
  keywords: "ellipse area calculator, area of ellipse, ellipse calculator, geometry calculator, math tool, area formula"
},
{
  path: "/PerimeterCircle",
  component: "PerimeterCircle",
  folder: "Geometry",
  title: "Circle Perimeter Calculator - Calculate Circumference of Circle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Circle Perimeter Calculator to calculate the circumference (perimeter) of a circle from radius or diameter.",
  keywords: "circle perimeter calculator, circumference calculator, circle circumference, geometry calculator, math tool, perimeter formula"
},
{
  path: "/PerimeterTriangle",
  component: "PerimeterTriangle",
  folder: "Geometry",
  title: "Triangle Perimeter Calculator - Calculate Perimeter of Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Triangle Perimeter Calculator to calculate the perimeter of a triangle from three side lengths.",
  keywords: "triangle perimeter calculator, perimeter of triangle, geometry calculator, triangle calculator, math tool, perimeter formula"
},
{
  path: "/PerimeterPolygon",
  component: "PerimeterPolygon",
  folder: "Geometry",
  title: "Polygon Perimeter Calculator - Calculate Perimeter of Polygon | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Polygon Perimeter Calculator to calculate the perimeter of regular and irregular polygons.",
  keywords: "polygon perimeter calculator, perimeter of polygon, geometry calculator, polygon calculator, math tool, perimeter formula"
},
{
  path: "/CoordinateDistance",
  component: "CoordinateDistance",
  folder: "Geometry",
  title: "Coordinate Distance Calculator - Calculate Distance Between Points | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Coordinate Distance Calculator to calculate distance between two points in 2D or 3D coordinate systems.",
  keywords: "coordinate distance calculator, distance between points, Euclidean distance, geometry calculator, math tool, coordinate geometry"
},
{
  path: "/MidpointCalculator",
  component: "MidpointCalculator",
  folder: "Geometry",
  title: "Midpoint Calculator - Find Midpoint Between Two Points | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Midpoint Calculator to find the midpoint between two points in 2D or 3D coordinate systems.",
  keywords: "midpoint calculator, find midpoint, coordinate geometry, geometry calculator, math tool, midpoint formula"
},
{
  path: "/SlopeCalculator",
  component: "SlopeCalculator",
  folder: "Geometry",
  title: "Slope Calculator - Calculate Slope of Line | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Slope Calculator to calculate the slope (gradient) of a line from two points or equation.",
  keywords: "slope calculator, gradient calculator, line slope, geometry calculator, math tool, slope formula"
},
{
  path: "/AngleCalculator",
  component: "AngleCalculator",
  folder: "Geometry",
  title: "Angle Calculator - Calculate Angles in Shapes | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Angle Calculator to calculate interior and exterior angles in triangles, polygons, and other shapes.",
  keywords: "angle calculator, angle finder, geometry calculator, angle measurement, math tool, angle formula"
},
{
  path: "/TriangleSideSolver",
  component: "TriangleSideSolver",
  folder: "Geometry",
  title: "Triangle Side Solver - Find Missing Side of Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Triangle Side Solver to find missing sides of triangles using various triangle theorems and formulas.",
  keywords: "triangle side solver, missing side calculator, triangle calculator, geometry calculator, math tool, triangle theorem"
},
{
  path: "/HeronsFormulaCalculator",
  component: "HeronsFormulaCalculator",
  folder: "Geometry",
  title: "Heron's Formula Calculator - Calculate Triangle Area from Sides | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Heron's Formula Calculator to calculate triangle area when all three side lengths are known.",
  keywords: "Heron's formula calculator, triangle area calculator, geometry calculator, Heron's formula, math tool, triangle calculation"
},
{
  path: "/TriangleHeight",
  component: "TriangleHeight",
  folder: "Geometry",
  title: "Triangle Height Calculator - Calculate Altitude of Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Triangle Height Calculator to calculate the altitude (height) of triangles from different known values.",
  keywords: "triangle height calculator, altitude calculator, triangle calculator, geometry calculator, math tool, triangle height"
},
{
  path: "/CircleSectorArea",
  component: "CircleSectorArea",
  folder: "Geometry",
  title: "Circle Sector Area Calculator - Calculate Sector Area | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Circle Sector Area Calculator to calculate the area of a circle sector from radius and angle.",
  keywords: "circle sector area calculator, sector area, circle sector, geometry calculator, math tool, sector formula"
},
{
  path: "/ArcLengthCalculator",
  component: "ArcLengthCalculator",
  folder: "Geometry",
  title: "Arc Length Calculator - Calculate Arc Length of Circle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Arc Length Calculator to calculate the arc length of a circle from radius and central angle.",
  keywords: "arc length calculator, circle arc length, geometry calculator, arc calculator, math tool, arc formula"
},
{
  path: "/VolumeCube",
  component: "VolumeCube",
  folder: "Geometry",
  title: "Cube Volume Calculator - Calculate Volume of Cube | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cube Volume Calculator to calculate the volume of a cube from side length or diagonal.",
  keywords: "cube volume calculator, volume of cube, geometry calculator, cube calculator, math tool, volume formula"
},
{
  path: "/VolumeCuboid",
  component: "VolumeCuboid",
  folder: "Geometry",
  title: "Cuboid Volume Calculator - Calculate Volume of Rectangular Prism | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cuboid Volume Calculator to calculate the volume of a cuboid (rectangular prism) from length, width, and height.",
  keywords: "cuboid volume calculator, volume of rectangular prism, geometry calculator, cuboid calculator, math tool, volume formula"
},
{
  path: "/VolumeSphere",
  component: "VolumeSphere",
  folder: "Geometry",
  title: "Sphere Volume Calculator - Calculate Volume of Sphere | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Sphere Volume Calculator to calculate the volume of a sphere from radius or diameter.",
  keywords: "sphere volume calculator, volume of sphere, geometry calculator, sphere calculator, math tool, volume formula"
},
{
  path: "/VolumeCylinder",
  component: "VolumeCylinder",
  folder: "Geometry",
  title: "Cylinder Volume Calculator - Calculate Volume of Cylinder | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cylinder Volume Calculator to calculate the volume of a cylinder from radius and height.",
  keywords: "cylinder volume calculator, volume of cylinder, geometry calculator, cylinder calculator, math tool, volume formula"
},
{
  path: "/VolumeCone",
  component: "VolumeCone",
  folder: "Geometry",
  title: "Cone Volume Calculator - Calculate Volume of Cone | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cone Volume Calculator to calculate the volume of a cone from radius and height.",
  keywords: "cone volume calculator, volume of cone, geometry calculator, cone calculator, math tool, volume formula"
},
{
  path: "/VolumePyramid",
  component: "VolumePyramid",
  folder: "Geometry",
  title: "Pyramid Volume Calculator - Calculate Volume of Pyramid | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Pyramid Volume Calculator to calculate the volume of square, rectangular, and triangular pyramids.",
  keywords: "pyramid volume calculator, volume of pyramid, geometry calculator, pyramid calculator, math tool, volume formula"
},
{
  path: "/FrustumVolume",
  component: "FrustumVolume",
  folder: "Geometry",
  title: "Frustum Volume Calculator - Calculate Volume of Frustum | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Frustum Volume Calculator to calculate the volume of conical or pyramidal frustums.",
  keywords: "frustum volume calculator, volume of frustum, truncated cone volume, geometry calculator, math tool, volume formula"
},
{
  path: "/SurfaceAreaCube",
  component: "SurfaceAreaCube",
  folder: "Geometry",
  title: "Cube Surface Area Calculator - Calculate Surface Area of Cube | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cube Surface Area Calculator to calculate the total surface area of a cube from side length.",
  keywords: "cube surface area calculator, surface area of cube, geometry calculator, cube calculator, math tool, surface area formula"
},
{
  path: "/SurfaceAreaSphere",
  component: "SurfaceAreaSphere",
  folder: "Geometry",
  title: "Sphere Surface Area Calculator - Calculate Surface Area of Sphere | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Sphere Surface Area Calculator to calculate the surface area of a sphere from radius or diameter.",
  keywords: "sphere surface area calculator, surface area of sphere, geometry calculator, sphere calculator, math tool, surface area formula"
},
{
  path: "/SurfaceAreaCone",
  component: "SurfaceAreaCone",
  folder: "Geometry",
  title: "Cone Surface Area Calculator - Calculate Surface Area of Cone | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cone Surface Area Calculator to calculate the total surface area of a cone from radius and slant height.",
  keywords: "cone surface area calculator, surface area of cone, geometry calculator, cone calculator, math tool, surface area formula"
},
{
  path: "/TriangleSolver",
  component: "TriangleSolver",
  folder: "Geometry",
  title: "Triangle Solver - Solve Any Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Triangle Solver to solve triangles given various combinations of sides and angles.",
  keywords: "triangle solver, triangle calculator, solve triangle, geometry calculator, math tool, triangle solver tool"
},
{
  path: "/AngleBisectorCalculator",
  component: "AngleBisectorCalculator",
  folder: "Geometry",
  title: "Angle Bisector Calculator - Calculate Angle Bisector Length | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Angle Bisector Calculator to calculate the length of angle bisectors in triangles.",
  keywords: "angle bisector calculator, bisector length, geometry calculator, triangle bisector, math tool, angle bisector formula"
},
{
  path: "/PythagoreanCalculator",
  component: "PythagoreanCalculator",
  folder: "Geometry",
  title: "Pythagorean Theorem Calculator - Calculate Triangle Sides | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Pythagorean Theorem Calculator to find missing sides of right triangles using Pythagorean theorem.",
  keywords: "Pythagorean theorem calculator, right triangle calculator, geometry calculator, Pythagorean calculator, math tool, triangle theorem"
},
{
  path: "/LawSinesCosines",
  component: "LawSinesCosines",
  folder: "Geometry",
  title: "Law of Sines & Cosines Calculator - Solve Triangles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Law of Sines & Cosines Calculator to solve triangles using sine law and cosine law formulas.",
  keywords: "law of sines calculator, law of cosines calculator, triangle solver, geometry calculator, math tool, trigonometry calculator"
},
{
  path: "/RightTriangleSolver",
  component: "RightTriangleSolver",
  folder: "Geometry",
  title: "Right Triangle Solver - Solve Right Triangles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Right Triangle Solver to solve right triangles given various combinations of sides and angles.",
  keywords: "right triangle solver, right triangle calculator, geometry calculator, triangle solver, math tool, right angle triangle"
},
{
  path: "/QuadrilateralCalculator",
  component: "QuadrilateralCalculator",
  folder: "Geometry",
  title: "Quadrilateral Calculator - Calculate Quadrilateral Properties | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Quadrilateral Calculator to calculate area, perimeter, and other properties of quadrilaterals.",
  keywords: "quadrilateral calculator, quadrilateral properties, geometry calculator, quadrilateral solver, math tool, four-sided shapes"
},
{
  path: "/CentroidCalculator",
  component: "CentroidCalculator",
  folder: "Geometry",
  title: "Centroid Calculator - Find Centroid of Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Centroid Calculator to find the centroid (center of mass) of triangles and other shapes.",
  keywords: "centroid calculator, triangle centroid, geometry calculator, center of mass, math tool, centroid formula"
},
{
  path: "/CircumcenterCalculator",
  component: "CircumcenterCalculator",
  folder: "Geometry",
  title: "Circumcenter Calculator - Find Circumcenter of Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Circumcenter Calculator to find the circumcenter and circumradius of triangles.",
  keywords: "circumcenter calculator, triangle circumcenter, circumradius, geometry calculator, math tool, circumcircle"
},
{
  path: "/IncenterCalculator",
  component: "IncenterCalculator",
  folder: "Geometry",
  title: "Incenter Calculator - Find Incenter of Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Incenter Calculator to find the incenter and inradius of triangles.",
  keywords: "incenter calculator, triangle incenter, inradius, geometry calculator, math tool, incircle"
},
{
  path: "/OrthocenterCalculator",
  component: "OrthocenterCalculator",
  folder: "Geometry",
  title: "Orthocenter Calculator - Find Orthocenter of Triangle | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Orthocenter Calculator to find the orthocenter of triangles from vertex coordinates.",
  keywords: "orthocenter calculator, triangle orthocenter, geometry calculator, triangle center, math tool, orthocenter finder"
},


//Algebra
{
  path: "/LinearEquationSolver",
  component: "LinearEquationSolver",
  folder: "Algebra",
  title: "Linear Equation Solver - Solve Linear Equations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Linear Equation Solver to solve linear equations step-by-step. Find solutions for equations with one variable.",
  keywords: "linear equation solver, algebra calculator, equation solver, math solver, algebra tool, linear equations"
},
{
  path: "/QuadraticEquationSolver",
  component: "QuadraticEquationSolver",
  folder: "Algebra",
  title: "Quadratic Equation Solver - Solve Quadratic Equations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Quadratic Equation Solver to solve quadratic equations using quadratic formula, factoring, or completing the square.",
  keywords: "quadratic equation solver, quadratic formula calculator, algebra calculator, math solver, equation solver, quadratic equations"
},
{
  path: "/PolynomialCalculator",
  component: "PolynomialCalculator",
  folder: "Algebra",
  title: "Polynomial Calculator - Solve & Factor Polynomials | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Polynomial Calculator to solve, factor, and simplify polynomial expressions. Find roots and factor polynomials.",
  keywords: "polynomial calculator, polynomial solver, polynomial factoring, algebra calculator, math tool, polynomial expressions"
},
{
  path: "/SystemEquationsSolver",
  component: "SystemEquationsSolver",
  folder: "Algebra",
  title: "System of Equations Solver - Solve Linear Systems | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's System of Equations Solver to solve systems of linear equations using substitution, elimination, or matrix methods.",
  keywords: "system of equations solver, linear system solver, algebra calculator, equation solver, math tool, simultaneous equations"
},
{
  path: "/ExpressionEvaluator",
  component: "ExpressionEvaluator",
  folder: "Algebra",
  title: "Expression Evaluator - Evaluate Algebraic Expressions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Expression Evaluator to evaluate and simplify algebraic expressions with variables, constants, and operations.",
  keywords: "expression evaluator, algebra calculator, expression simplifier, math evaluator, algebra tool, expression calculator"
},
{
  path: "/InequalityCalculator",
  component: "InequalityCalculator",
  folder: "Algebra",
  title: "Inequality Calculator - Solve Inequalities | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Inequality Calculator to solve linear, quadratic, and polynomial inequalities. Find solution sets graphically.",
  keywords: "inequality calculator, inequality solver, algebra calculator, math tool, solve inequalities, inequality solutions"
},
{
  path: "/FactorizationCalculator",
  component: "FactorizationCalculator",
  folder: "Algebra",
  title: "Factorization Calculator - Factor Expressions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Factorization Calculator to factor algebraic expressions, polynomials, and quadratic expressions completely.",
  keywords: "factorization calculator, factor calculator, algebra tool, polynomial factoring, math calculator, factor expressions"
},
{
  path: "/SyntheticDivision",
  component: "SyntheticDivision",
  folder: "Algebra",
  title: "Synthetic Division Calculator - Divide Polynomials | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Synthetic Division Calculator to divide polynomials using synthetic division method. Find quotients and remainders.",
  keywords: "synthetic division calculator, polynomial division, algebra calculator, math tool, divide polynomials, synthetic division method"
},
{
  path: "/ComplexRootsFinder",
  component: "ComplexRootsFinder",
  folder: "Algebra",
  title: "Complex Roots Finder - Find Complex Roots of Equations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Roots Finder to find complex roots of polynomial equations. Solve equations with complex solutions.",
  keywords: "complex roots finder, complex solutions, polynomial roots, algebra calculator, math tool, complex numbers"
},
{
  path: "/ParabolaCalculator",
  component: "ParabolaCalculator",
  folder: "Algebra",
  title: "Parabola Calculator - Analyze Parabolic Equations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Parabola Calculator to analyze parabola properties: vertex, focus, directrix, axis of symmetry, and more.",
  keywords: "parabola calculator, parabola properties, vertex calculator, algebra tool, conic sections, quadratic functions"
},
{
  path: "/MatrixDeterminant",
  component: "MatrixDeterminant",
  folder: "Algebra",
  title: "Matrix Determinant Calculator - Calculate Determinant | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Determinant Calculator to calculate determinant of 2x2, 3x3, and larger matrices. Step-by-step solutions.",
  keywords: "matrix determinant calculator, determinant calculator, algebra calculator, matrix tool, linear algebra, determinant finder"
},
{
  path: "/MatrixInverse",
  component: "MatrixInverse",
  folder: "Algebra",
  title: "Matrix Inverse Calculator - Find Inverse of Matrix | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Inverse Calculator to find inverse of square matrices using adjoint method or row reduction.",
  keywords: "matrix inverse calculator, inverse matrix, algebra calculator, matrix tool, linear algebra, matrix operations"
},
{
  path: "/MatrixAdditionSubtraction",
  component: "MatrixAdditionSubtraction",
  folder: "Algebra",
  title: "Matrix Addition/Subtraction Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Addition/Subtraction Calculator to add and subtract matrices of compatible dimensions.",
  keywords: "matrix addition calculator, matrix subtraction, matrix operations, algebra calculator, linear algebra, matrix math"
},
{
  path: "/MatrixMultiplication",
  component: "MatrixMultiplication",
  folder: "Algebra",
  title: "Matrix Multiplication Calculator - Multiply Matrices | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Multiplication Calculator to multiply matrices with compatible dimensions. Calculate matrix products.",
  keywords: "matrix multiplication calculator, multiply matrices, matrix product, algebra calculator, linear algebra, matrix operations"
},
{
  path: "/EigenvalueCalculator",
  component: "EigenvalueCalculator",
  folder: "Algebra",
  title: "Eigenvalue Calculator - Find Eigenvalues & Eigenvectors | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Eigenvalue Calculator to find eigenvalues and eigenvectors of square matrices. Linear algebra tool.",
  keywords: "eigenvalue calculator, eigenvector calculator, linear algebra, matrix calculator, algebra tool, eigenvalue finder"
},
{
  path: "/MatrixRank",
  component: "MatrixRank",
  folder: "Algebra",
  title: "Matrix Rank Calculator - Calculate Matrix Rank | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Rank Calculator to calculate the rank of matrices using row reduction or determinant methods.",
  keywords: "matrix rank calculator, rank of matrix, linear algebra, algebra calculator, matrix tool, matrix rank"
},
{
  path: "/MatrixTranspose",
  component: "MatrixTranspose",
  folder: "Algebra",
  title: "Matrix Transpose Calculator - Transpose Matrices | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Transpose Calculator to transpose matrices. Convert rows to columns and columns to rows.",
  keywords: "matrix transpose calculator, transpose matrix, linear algebra, algebra calculator, matrix tool, matrix operations"
},
{
  path: "/MatrixTrace",
  component: "MatrixTrace",
  folder: "Algebra",
  title: "Matrix Trace Calculator - Calculate Trace of Matrix | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Trace Calculator to calculate trace (sum of diagonal elements) of square matrices.",
  keywords: "matrix trace calculator, trace of matrix, linear algebra, algebra calculator, matrix tool, diagonal sum"
},
{
  path: "/MatrixAdjugate",
  component: "MatrixAdjugate",
  folder: "Algebra",
  title: "Matrix Adjugate Calculator - Calculate Adjugate Matrix | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Adjugate Calculator to calculate adjugate (adjoint) matrix for finding inverse matrices.",
  keywords: "matrix adjugate calculator, adjoint matrix, linear algebra, algebra calculator, matrix tool, matrix inverse"
},
{
  path: "/MatrixPower",
  component: "MatrixPower",
  folder: "Algebra",
  title: "Matrix Power Calculator - Calculate Matrix Powers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Matrix Power Calculator to raise matrices to integer powers. Calculate matrix exponentiation.",
  keywords: "matrix power calculator, matrix exponentiation, linear algebra, algebra calculator, matrix tool, matrix powers"
},
{
  path: "/ArithmeticSequence",
  component: "ArithmeticSequence",
  folder: "Algebra",
  title: "Arithmetic Sequence Calculator - Find Sequence Terms | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Arithmetic Sequence Calculator to find terms, common difference, and sum of arithmetic sequences.",
  keywords: "arithmetic sequence calculator, sequence calculator, algebra tool, math calculator, arithmetic progression, sequence terms"
},
{
  path: "/GeometricSequence",
  component: "GeometricSequence",
  folder: "Algebra",
  title: "Geometric Sequence Calculator - Find Sequence Terms | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Geometric Sequence Calculator to find terms, common ratio, and sum of geometric sequences.",
  keywords: "geometric sequence calculator, sequence calculator, algebra tool, math calculator, geometric progression, sequence terms"
},
{
  path: "/BinomialExpansion",
  component: "BinomialExpansion",
  folder: "Algebra",
  title: "Binomial Expansion Calculator - Expand Binomials | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Binomial Expansion Calculator to expand binomial expressions using binomial theorem and Pascal's triangle.",
  keywords: "binomial expansion calculator, binomial theorem, algebra calculator, math tool, expand binomials, Pascal's triangle"
},
{
  path: "/LogarithmCalculator",
  component: "LogarithmCalculator",
  folder: "Algebra",
  title: "Logarithm Calculator - Calculate Logarithms | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Logarithm Calculator to calculate logarithms with any base, natural logs, and common logs.",
  keywords: "logarithm calculator, log calculator, algebra calculator, math tool, natural logarithm, common logarithm"
},
{
  path: "/DistanceFormula",
  component: "DistanceFormula",
  folder: "Algebra",
  title: "Distance Formula Calculator - Calculate Distance | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Distance Formula Calculator to calculate distance between two points in coordinate geometry.",
  keywords: "distance formula calculator, coordinate geometry, algebra calculator, math tool, distance between points, Euclidean distance"
},
{
  path: "/FibonacciSequence",
  component: "FibonacciSequence",
  folder: "Algebra",
  title: "Fibonacci Sequence Calculator - Generate Fibonacci Numbers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Fibonacci Sequence Calculator to generate Fibonacci numbers and explore Fibonacci sequence properties.",
  keywords: "Fibonacci sequence calculator, Fibonacci numbers, sequence generator, algebra tool, math calculator, Fibonacci series"
},
{
  path: "/ArithmeticSeries",
  component: "ArithmeticSeries",
  folder: "Algebra",
  title: "Arithmetic Series Calculator - Calculate Series Sum | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Arithmetic Series Calculator to calculate sum of arithmetic series and find series properties.",
  keywords: "arithmetic series calculator, series sum calculator, algebra calculator, math tool, arithmetic progression sum, series calculator"
},
{
  path: "/GeometricSeries",
  component: "GeometricSeries",
  folder: "Algebra",
  title: "Geometric Series Calculator - Calculate Series Sum | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Geometric Series Calculator to calculate sum of finite geometric series and find series properties.",
  keywords: "geometric series calculator, series sum calculator, algebra calculator, math tool, geometric progression sum, series calculator"
},
{
  path: "/InfiniteGeometricSeries",
  component: "InfiniteGeometricSeries",
  folder: "Algebra",
  title: "Infinite Geometric Series Calculator - Calculate Sum to Infinity | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Infinite Geometric Series Calculator to calculate sum of infinite geometric series when convergent.",
  keywords: "infinite geometric series calculator, sum to infinity, algebra calculator, math tool, infinite series, convergent series"
},
{
  path: "/PartialSum",
  component: "PartialSum",
  folder: "Algebra",
  title: "Partial Sum Calculator - Calculate Partial Sums of Series | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Partial Sum Calculator to calculate partial sums of arithmetic, geometric, and other series.",
  keywords: "partial sum calculator, series calculator, algebra tool, math calculator, sum of series, partial sums"
},
{
  path: "/ComplexNumberCalculator",
  component: "ComplexNumberCalculator",
  folder: "Algebra",
  title: "Complex Number Calculator - Calculate with Complex Numbers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Number Calculator to perform operations with complex numbers: addition, subtraction, multiplication, division.",
  keywords: "complex number calculator, complex numbers, algebra calculator, math tool, imaginary numbers, complex operations"
},
{
  path: "/ComplexModulus",
  component: "ComplexModulus",
  folder: "Algebra",
  title: "Complex Modulus Calculator - Calculate Absolute Value | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Modulus Calculator to calculate modulus (absolute value) of complex numbers.",
  keywords: "complex modulus calculator, absolute value complex, algebra calculator, math tool, complex numbers, modulus finder"
},
{
  path: "/ComplexConjugate",
  component: "ComplexConjugate",
  folder: "Algebra",
  title: "Complex Conjugate Calculator - Find Conjugate | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Conjugate Calculator to find conjugate of complex numbers and perform conjugate operations.",
  keywords: "complex conjugate calculator, conjugate of complex number, algebra calculator, math tool, complex numbers, complex conjugate"
},
{
  path: "/ComplexArgument",
  component: "ComplexArgument",
  folder: "Algebra",
  title: "Complex Argument Calculator - Calculate Argument (Angle) | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Argument Calculator to calculate argument (angle) of complex numbers in polar form.",
  keywords: "complex argument calculator, argument of complex number, algebra calculator, math tool, complex numbers, polar coordinates"
},
{
  path: "/ComplexPolarForm",
  component: "ComplexPolarForm",
  folder: "Algebra",
  title: "Complex Polar Form Calculator - Convert to Polar Form | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Polar Form Calculator to convert complex numbers between rectangular and polar forms.",
  keywords: "complex polar form calculator, polar form converter, algebra calculator, math tool, complex numbers, polar coordinates"
},
{
  path: "/EulersFormula",
  component: "EulersFormula",
  folder: "Algebra",
  title: "Euler's Formula Calculator - Euler's Identity Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Euler's Formula Calculator to explore Euler's formula and Euler's identity with complex numbers.",
  keywords: "Euler's formula calculator, Euler's identity, complex numbers, algebra calculator, math tool, exponential form"
},
{
  path: "/ComplexExponential",
  component: "ComplexExponential",
  folder: "Algebra",
  title: "Complex Exponential Calculator - Calculate e^z | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Exponential Calculator to calculate exponential of complex numbers using Euler's formula.",
  keywords: "complex exponential calculator, exponential of complex number, algebra calculator, math tool, complex numbers, Euler's formula"
},
{
  path: "/ComplexLogarithm",
  component: "ComplexLogarithm",
  folder: "Algebra",
  title: "Complex Logarithm Calculator - Calculate Log of Complex Numbers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Logarithm Calculator to calculate logarithm of complex numbers with multiple branches.",
  keywords: "complex logarithm calculator, log of complex number, algebra calculator, math tool, complex numbers, complex log"
},
{
  path: "/ComplexAddSubtract",
  component: "ComplexAddSubtract",
  folder: "Algebra",
  title: "Complex Add/Subtract Calculator - Complex Number Operations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Add/Subtract Calculator to add and subtract complex numbers in rectangular form.",
  keywords: "complex add subtract calculator, complex number operations, algebra calculator, math tool, complex arithmetic, imaginary numbers"
},


//Trigonometry
{
  path: "/SineCalculator",
  component: "SineCalculator",
  folder: "Trigonometry",
  title: "Sine Calculator - Calculate Sine of Angles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Sine Calculator to calculate sine values for angles in degrees, radians, or gradians. Find sin(x) for any angle.",
  keywords: "sine calculator, sin calculator, trigonometry calculator, math tool, sine function, trigonometric functions"
},
{
  path: "/CosineCalculator",
  component: "CosineCalculator",
  folder: "Trigonometry",
  title: "Cosine Calculator - Calculate Cosine of Angles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cosine Calculator to calculate cosine values for angles in degrees, radians, or gradians. Find cos(x) for any angle.",
  keywords: "cosine calculator, cos calculator, trigonometry calculator, math tool, cosine function, trigonometric functions"
},
{
  path: "/TangentCalculator",
  component: "TangentCalculator",
  folder: "Trigonometry",
  title: "Tangent Calculator - Calculate Tangent of Angles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Tangent Calculator to calculate tangent values for angles in degrees, radians, or gradians. Find tan(x) for any angle.",
  keywords: "tangent calculator, tan calculator, trigonometry calculator, math tool, tangent function, trigonometric functions"
},
{
  path: "/CotSecCosecCalculator",
  component: "CotSecCosecCalculator",
  folder: "Trigonometry",
  title: "Cotangent, Secant, Cosecant Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cotangent, Secant, Cosecant Calculator to calculate reciprocal trigonometric functions: cot, sec, csc.",
  keywords: "cotangent calculator, secant calculator, cosecant calculator, trigonometry calculator, reciprocal trig functions, math tool"
},
{
  path: "/InverseTrigCalculator",
  component: "InverseTrigCalculator",
  folder: "Trigonometry",
  title: "Inverse Trigonometric Functions Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Inverse Trig Calculator to calculate inverse sine, cosine, tangent (arcsin, arccos, arctan) functions.",
  keywords: "inverse trig calculator, arcsin calculator, arccos calculator, arctan calculator, trigonometry calculator, inverse functions"
},
{
  path: "/TrigIdentitiesCalculator",
  component: "TrigIdentitiesCalculator",
  folder: "Trigonometry",
  title: "Trigonometric Identities Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Trig Identities Calculator to verify and simplify trigonometric identities and expressions.",
  keywords: "trig identities calculator, trigonometric identities, identity verifier, trigonometry calculator, math tool, trig simplifier"
},
{
  path: "/UnitCircleCalculator",
  component: "UnitCircleCalculator",
  folder: "Trigonometry",
  title: "Unit Circle Calculator - Unit Circle Values & Coordinates | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Unit Circle Calculator to find trigonometric values, coordinates, and angles on the unit circle.",
  keywords: "unit circle calculator, trigonometry calculator, math tool, unit circle values, trigonometric coordinates, angle calculator"
},
{
  path: "/ReciprocalTrigCalculator",
  component: "ReciprocalTrigCalculator",
  folder: "Trigonometry",
  title: "Reciprocal Trigonometric Functions Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Reciprocal Trig Calculator to calculate reciprocal trigonometric functions and their relationships.",
  keywords: "reciprocal trig calculator, trigonometry calculator, math tool, reciprocal functions, trig relationships, trigonometric calculator"
},
{
  path: "/TrigValuesSpecialAngles",
  component: "TrigValuesSpecialAngles",
  folder: "Trigonometry",
  title: "Trig Values for Special Angles Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Special Angles Calculator to find trigonometric values for special angles (0°, 30°, 45°, 60°, 90°, etc.).",
  keywords: "special angles calculator, trig values calculator, trigonometry calculator, math tool, exact trig values, trigonometric tables"
},
{
  path: "/TrigFunctionSimplifier",
  component: "TrigFunctionSimplifier",
  folder: "Trigonometry",
  title: "Trigonometric Function Simplifier | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Trig Function Simplifier to simplify complex trigonometric expressions using identities and formulas.",
  keywords: "trig function simplifier, trigonometry calculator, math tool, expression simplifier, trigonometric simplification, algebra tool"
},
{
  path: "/SOHCAHTOACalculator",
  component: "SOHCAHTOACalculator",
  folder: "Trigonometry",
  title: "SOHCAHTOA Calculator - Right Triangle Trigonometry | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's SOHCAHTOA Calculator to solve right triangles using SOHCAHTOA method. Find sides and angles.",
  keywords: "SOHCAHTOA calculator, right triangle calculator, trigonometry calculator, math tool, triangle solver, trigonometric ratios"
},
{
  path: "/LawOfSines",
  component: "LawOfSines",
  folder: "Trigonometry",
  title: "Law of Sines Calculator - Solve Triangles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Law of Sines Calculator to solve triangles using sine law. Find missing sides and angles in any triangle.",
  keywords: "law of sines calculator, sine law calculator, trigonometry calculator, triangle solver, math tool, oblique triangles"
},
{
  path: "/LawOfCosines",
  component: "LawOfCosines",
  folder: "Trigonometry",
  title: "Law of Cosines Calculator - Solve Triangles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Law of Cosines Calculator to solve triangles using cosine law. Find missing sides and angles.",
  keywords: "law of cosines calculator, cosine law calculator, trigonometry calculator, triangle solver, math tool, oblique triangles"
},
{
  path: "/AngleElevationDepression",
  component: "AngleElevationDepression",
  folder: "Trigonometry",
  title: "Angle of Elevation & Depression Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Angle of Elevation & Depression Calculator to solve real-world trigonometry problems involving heights and distances.",
  keywords: "angle of elevation calculator, angle of depression calculator, trigonometry calculator, math tool, height and distance, real-world trigonometry"
},
{
  path: "/ObliqueTriangleSolver",
  component: "ObliqueTriangleSolver",
  folder: "Trigonometry",
  title: "Oblique Triangle Solver - Solve Non-Right Triangles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Oblique Triangle Solver to solve triangles without right angles using laws of sines and cosines.",
  keywords: "oblique triangle solver, non-right triangle calculator, trigonometry calculator, triangle solver, math tool, law of sines cosines"
},
{
  path: "/SSAAmbiguousCaseSolver",
  component: "SSAAmbiguousCaseSolver",
  folder: "Trigonometry",
  title: "SSA Ambiguous Case Solver - Triangle Solutions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's SSA Ambiguous Case Solver to handle ambiguous cases in triangle solving where multiple solutions exist.",
  keywords: "SSA ambiguous case solver, triangle solver, trigonometry calculator, ambiguous case calculator, math tool, multiple triangle solutions"
},
{
  path: "/TrigonometricEquationSolver",
  component: "TrigonometricEquationSolver",
  folder: "Trigonometry",
  title: "Trigonometric Equation Solver | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Trigonometric Equation Solver to solve equations involving trigonometric functions and find all solutions.",
  keywords: "trigonometric equation solver, trig equation calculator, trigonometry calculator, math tool, equation solver, trig solutions"
},
{
  path: "/ReferenceAngleSolver",
  component: "ReferenceAngleSolver",
  folder: "Trigonometry",
  title: "Reference Angle Calculator - Find Reference Angles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Reference Angle Calculator to find reference angles for any given angle in degrees or radians.",
  keywords: "reference angle calculator, trigonometry calculator, math tool, angle calculator, reference angle finder, trigonometric angles"
},
{
  path: "/AngleBetweenTwoLines",
  component: "AngleBetweenTwoLines",
  folder: "Trigonometry",
  title: "Angle Between Two Lines Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Angle Between Two Lines Calculator to calculate the angle between two lines using slopes or equations.",
  keywords: "angle between two lines calculator, trigonometry calculator, geometry calculator, math tool, line angle calculator, slope calculator"
},
{
  path: "/TriangleClassificationCalculator",
  component: "TriangleClassificationCalculator",
  folder: "Trigonometry",
  title: "Triangle Classification Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Triangle Classification Calculator to classify triangles by sides (scalene, isosceles, equilateral) and angles (acute, right, obtuse).",
  keywords: "triangle classification calculator, triangle type identifier, geometry calculator, math tool, triangle classifier, triangle properties"
},
{
  path: "/DegreeRadianConverter",
  component: "DegreeRadianConverter",
  folder: "Trigonometry",
  title: "Degree to Radian Converter | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Degree to Radian Converter to convert between degrees and radians easily and accurately.",
  keywords: "degree to radian converter, radian to degree converter, angle converter, trigonometry calculator, math tool, angle conversion"
},
{
  path: "/DegreeMinuteSecondConverter",
  component: "DegreeMinuteSecondConverter",
  folder: "Trigonometry",
  title: "Degree Minute Second (DMS) Converter | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's DMS Converter to convert between degrees-minutes-seconds and decimal degrees formats.",
  keywords: "degree minute second converter, DMS converter, angle converter, trigonometry calculator, math tool, coordinate conversion"
},
{
  path: "/RadianDMSConverter",
  component: "RadianDMSConverter",
  folder: "Trigonometry",
  title: "Radian to DMS Converter | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Radian to DMS Converter to convert radians to degrees-minutes-seconds format and vice versa.",
  keywords: "radian to DMS converter, angle converter, trigonometry calculator, math tool, radian conversion, DMS format"
},
{
  path: "/GradianConverter",
  component: "GradianConverter",
  folder: "Trigonometry",
  title: "Gradian Converter - Convert to/from Gradians | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Gradian Converter to convert between gradians, degrees, and radians. Gradian angle measurement tool.",
  keywords: "gradian converter, angle converter, trigonometry calculator, math tool, gradian measurement, angle units"
},
{
  path: "/DecimalDegreesConverter",
  component: "DecimalDegreesConverter",
  folder: "Trigonometry",
  title: "Decimal Degrees Converter | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Decimal Degrees Converter to convert between decimal degrees and degrees-minutes-seconds formats.",
  keywords: "decimal degrees converter, angle converter, trigonometry calculator, math tool, coordinate conversion, decimal to DMS"
},
{
  path: "/SlopeAngleConverter",
  component: "SlopeAngleConverter",
  folder: "Trigonometry",
  title: "Slope to Angle Converter | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Slope to Angle Converter to convert between slope (gradient) and angle in degrees or radians.",
  keywords: "slope to angle converter, angle converter, trigonometry calculator, math tool, gradient calculator, slope angle"
},
{
  path: "/CoterminalAngleCalculator",
  component: "CoterminalAngleCalculator",
  folder: "Trigonometry",
  title: "Coterminal Angle Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Coterminal Angle Calculator to find coterminal angles (positive and negative) for any given angle.",
  keywords: "coterminal angle calculator, trigonometry calculator, math tool, angle calculator, coterminal angles, angle relationships"
},
{
  path: "/ArcMeasureCalculator",
  component: "ArcMeasureCalculator",
  folder: "Trigonometry",
  title: "Arc Measure Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Arc Measure Calculator to calculate arc measures in circles given radius and central angle.",
  keywords: "arc measure calculator, circle calculator, trigonometry calculator, math tool, arc length, circle geometry"
},
{
  path: "/CircleSectorCalculator",
  component: "CircleSectorCalculator",
  folder: "Trigonometry",
  title: "Circle Sector Calculator - Sector Area & Arc Length | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Circle Sector Calculator to calculate sector area and arc length for given radius and central angle.",
  keywords: "circle sector calculator, sector area calculator, arc length calculator, trigonometry calculator, math tool, circle geometry"
},
{
  path: "/RotationSenseCalculator",
  component: "RotationSenseCalculator",
  folder: "Trigonometry",
  title: "Rotation Sense Calculator - Clockwise/Counterclockwise | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Rotation Sense Calculator to determine direction of rotation (clockwise/counterclockwise) from angle changes.",
  keywords: "rotation sense calculator, direction calculator, trigonometry calculator, math tool, rotation direction, clockwise counterclockwise"
},
{
  path: "/AngleDirectionConverter",
  component: "AngleDirectionConverter",
  folder: "Trigonometry",
  title: "Angle Direction Converter - Convert Between Conventions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Angle Direction Converter to convert angles between different directional conventions and coordinate systems.",
  keywords: "angle direction converter, coordinate converter, trigonometry calculator, math tool, angle conventions, directional angles"
},
{
  path: "/BearingAngleConverter",
  component: "BearingAngleConverter",
  folder: "Trigonometry",
  title: "Bearing Angle Converter - Convert Bearings | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Bearing Angle Converter to convert between different bearing systems (true, magnetic, compass).",
  keywords: "bearing angle converter, bearing calculator, trigonometry calculator, navigation tool, math tool, angle conversion"
},
{
  path: "/ComplementSupplementCalculator",
  component: "ComplementSupplementCalculator",
  folder: "Trigonometry",
  title: "Complement & Supplement Angle Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complement & Supplement Calculator to find complementary and supplementary angles for any given angle.",
  keywords: "complement angle calculator, supplement angle calculator, trigonometry calculator, math tool, angle relationships, complementary supplementary"
},
{
  path: "/TurnAngleCalculator",
  component: "TurnAngleCalculator",
  folder: "Trigonometry",
  title: "Turn Angle Calculator - Calculate Turns in Degrees | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Turn Angle Calculator to calculate turn angles in degrees for navigation and rotational problems.",
  keywords: "turn angle calculator, navigation calculator, trigonometry calculator, math tool, turning angles, rotation calculator"
},
{
  path: "/AngleBetweenVectors",
  component: "AngleBetweenVectors",
  folder: "Trigonometry",
  title: "Angle Between Vectors Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Angle Between Vectors Calculator to calculate angle between two vectors using dot product formula.",
  keywords: "angle between vectors calculator, vector calculator, trigonometry calculator, math tool, dot product, vector angle"
},


//Calculus
{
  path: "/DerivativeCalculator",
  component: "DerivativeCalculator",
  folder: "Calculus",
  title: "Derivative Calculator - Calculate Derivatives Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Derivative Calculator to find derivatives of functions step-by-step. Supports polynomials, trigonometric, exponential, and logarithmic functions.",
  keywords: "derivative calculator, differentiation calculator, calculus calculator, derivative finder, math solver, derivative solver"
},
{
  path: "/PartialDerivativeCalculator",
  component: "PartialDerivativeCalculator",
  folder: "Calculus",
  title: "Partial Derivative Calculator - Calculate Partial Derivatives | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Partial Derivative Calculator to find partial derivatives of multivariable functions with respect to specific variables.",
  keywords: "partial derivative calculator, partial differentiation, multivariable calculus, calculus calculator, math tool, partial derivatives"
},
{
  path: "/DerivativeFunctionPlotter",
  component: "DerivativeFunctionPlotter",
  folder: "Calculus",
  title: "Derivative Function Plotter - Graph Derivatives | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Derivative Function Plotter to visualize derivatives and their graphs alongside original functions.",
  keywords: "derivative plotter, function grapher, calculus calculator, graph derivatives, math visualization, derivative visualization"
},
{
  path: "/LimitCalculator",
  component: "LimitCalculator",
  folder: "Calculus",
  title: "Limit Calculator - Calculate Limits of Functions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Limit Calculator to find limits of functions as variables approach specific values or infinity.",
  keywords: "limit calculator, calculus calculator, limit finder, math solver, limit evaluation, function limits"
},
{
  path: "/MeanValueTheoremCalculator",
  component: "MeanValueTheoremCalculator",
  folder: "Calculus",
  title: "Mean Value Theorem Calculator - MVT Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Mean Value Theorem Calculator to verify and apply the Mean Value Theorem for differentiable functions.",
  keywords: "mean value theorem calculator, MVT calculator, calculus calculator, math tool, theorem verifier, calculus theorems"
},
{
  path: "/HigherOrderDerivativeCalculator",
  component: "HigherOrderDerivativeCalculator",
  folder: "Calculus",
  title: "Higher Order Derivative Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Higher Order Derivative Calculator to find second, third, and nth derivatives of functions.",
  keywords: "higher order derivative calculator, second derivative, third derivative, calculus calculator, math tool, nth derivative"
},
{
  path: "/ImplicitDifferentiation",
  component: "ImplicitDifferentiation",
  folder: "Calculus",
  title: "Implicit Differentiation Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Implicit Differentiation Calculator to find derivatives of implicitly defined functions.",
  keywords: "implicit differentiation calculator, calculus calculator, math tool, implicit derivative, differentiation solver"
},
{
  path: "/DirectionalDerivativeCalculator",
  component: "DirectionalDerivativeCalculator",
  folder: "Calculus",
  title: "Directional Derivative Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Directional Derivative Calculator to calculate directional derivatives of multivariable functions.",
  keywords: "directional derivative calculator, multivariable calculus, gradient calculator, calculus calculator, math tool, vector calculus"
},
{
  path: "/DerivativeAtPoint",
  component: "DerivativeAtPoint",
  folder: "Calculus",
  title: "Derivative at Point Calculator - Instantaneous Rate of Change | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Derivative at Point Calculator to find derivative values at specific points and instantaneous rates of change.",
  keywords: "derivative at point calculator, instantaneous rate of change, calculus calculator, math tool, point derivative, slope at point"
},
{
  path: "/LogarithmicDifferentiation",
  component: "LogarithmicDifferentiation",
  folder: "Calculus",
  title: "Logarithmic Differentiation Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Logarithmic Differentiation Calculator to differentiate complex functions using logarithmic differentiation technique.",
  keywords: "logarithmic differentiation calculator, calculus calculator, math tool, complex derivatives, differentiation technique"
},
{
  path: "/IntegralCalculator",
  component: "IntegralCalculator",
  folder: "Calculus",
  title: "Integral Calculator - Calculate Integrals Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Integral Calculator to find definite and indefinite integrals of functions with step-by-step solutions.",
  keywords: "integral calculator, integration calculator, calculus calculator, antiderivative calculator, math solver, integral solver"
},
{
  path: "/AreaUnderCurve",
  component: "AreaUnderCurve",
  folder: "Calculus",
  title: "Area Under Curve Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Area Under Curve Calculator to calculate the area between a function and the x-axis over specified intervals.",
  keywords: "area under curve calculator, calculus calculator, area calculator, math tool, definite integral, curve area"
},
{
  path: "/RiemannSumCalculator",
  component: "RiemannSumCalculator",
  folder: "Calculus",
  title: "Riemann Sum Calculator - Approximate Integrals | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Riemann Sum Calculator to approximate definite integrals using left, right, midpoint, and trapezoidal Riemann sums.",
  keywords: "Riemann sum calculator, integral approximation, calculus calculator, math tool, numerical integration, approximation methods"
},
{
  path: "/DoubleIntegralCalculator",
  component: "DoubleIntegralCalculator",
  folder: "Calculus",
  title: "Double Integral Calculator - Calculate Double Integrals | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Double Integral Calculator to evaluate double integrals over rectangular and non-rectangular regions.",
  keywords: "double integral calculator, multivariable calculus, calculus calculator, math tool, iterated integrals, integration"
},
{
  path: "/TripleIntegralCalculator",
  component: "TripleIntegralCalculator",
  folder: "Calculus",
  title: "Triple Integral Calculator - Calculate Triple Integrals | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Triple Integral Calculator to evaluate triple integrals over three-dimensional regions.",
  keywords: "triple integral calculator, multivariable calculus, calculus calculator, math tool, volume integrals, 3D integration"
},
{
  path: "/ImproperIntegralCalculator",
  component: "ImproperIntegralCalculator",
  folder: "Calculus",
  title: "Improper Integral Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Improper Integral Calculator to evaluate integrals with infinite limits or integrands with discontinuities.",
  keywords: "improper integral calculator, calculus calculator, math tool, infinite integrals, convergence test, divergent integrals"
},
{
  path: "/VolumeOfRevolution",
  component: "VolumeOfRevolution",
  folder: "Calculus",
  title: "Volume of Revolution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Volume of Revolution Calculator to find volumes of solids generated by revolving curves around axes.",
  keywords: "volume of revolution calculator, calculus calculator, math tool, solid volume, disk method, shell method"
},
{
  path: "/IntegrationByParts",
  component: "IntegrationByParts",
  folder: "Calculus",
  title: "Integration by Parts Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Integration by Parts Calculator to solve integrals using the integration by parts formula and technique.",
  keywords: "integration by parts calculator, calculus calculator, math tool, integration technique, uv substitution, integral solver"
},
{
  path: "/SubstitutionMethod",
  component: "SubstitutionMethod",
  folder: "Calculus",
  title: "Substitution Method Calculator - U-Substitution | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Substitution Method Calculator to solve integrals using u-substitution (change of variables) method.",
  keywords: "substitution method calculator, u-substitution calculator, calculus calculator, math tool, integration technique, variable substitution"
},
{
  path: "/SurfaceAreaIntegral",
  component: "SurfaceAreaIntegral",
  folder: "Calculus",
  title: "Surface Area Integral Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Surface Area Integral Calculator to calculate surface areas of revolution and parametric surfaces.",
  keywords: "surface area integral calculator, calculus calculator, math tool, surface area, revolution surfaces, parametric surfaces"
},
{
  path: "/DifferentialEquationsSolver",
  component: "DifferentialEquationsSolver",
  folder: "Calculus",
  title: "Differential Equations Solver | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Differential Equations Solver to solve ordinary differential equations (ODEs) with various methods.",
  keywords: "differential equations solver, ODE solver, calculus calculator, math tool, equation solver, first order ODE, second order ODE"
},
{
  path: "/TaylorSeriesCalculator",
  component: "TaylorSeriesCalculator",
  folder: "Calculus",
  title: "Taylor Series Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Taylor Series Calculator to find Taylor and Maclaurin series expansions of functions around points.",
  keywords: "Taylor series calculator, Maclaurin series calculator, calculus calculator, math tool, series expansion, polynomial approximation"
},
{
  path: "/LaplaceTransformCalculator",
  component: "LaplaceTransformCalculator",
  folder: "Calculus",
  title: "Laplace Transform Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Laplace Transform Calculator to compute Laplace transforms of functions and solve differential equations.",
  keywords: "Laplace transform calculator, calculus calculator, math tool, integral transform, differential equations, transform methods"
},
{
  path: "/InverseLaplaceTransform",
  component: "InverseLaplaceTransform",
  folder: "Calculus",
  title: "Inverse Laplace Transform Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Inverse Laplace Transform Calculator to compute inverse Laplace transforms and recover original functions.",
  keywords: "inverse Laplace transform calculator, calculus calculator, math tool, inverse transform, Laplace inversion, transform methods"
},
{
  path: "/VectorCalculusCalculator",
  component: "VectorCalculusCalculator",
  folder: "Calculus",
  title: "Vector Calculus Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Vector Calculus Calculator for gradient, divergence, curl, and line/surface integrals in vector fields.",
  keywords: "vector calculus calculator, gradient calculator, divergence calculator, curl calculator, multivariable calculus, math tool"
},
{
  path: "/FourierSeriesCalculator",
  component: "FourierSeriesCalculator",
  folder: "Calculus",
  title: "Fourier Series Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Fourier Series Calculator to compute Fourier series coefficients and expansions for periodic functions.",
  keywords: "Fourier series calculator, Fourier coefficients calculator, calculus calculator, math tool, periodic functions, harmonic analysis"
},
{
  path: "/GreensTheoremCalculator",
  component: "GreensTheoremCalculator",
  folder: "Calculus",
  title: "Green's Theorem Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Green's Theorem Calculator to apply Green's theorem for converting line integrals to double integrals.",
  keywords: "Green's theorem calculator, vector calculus, calculus calculator, math tool, line integrals, double integrals"
},
{
  path: "/StokesTheoremCalculator",
  component: "StokesTheoremCalculator",
  folder: "Calculus",
  title: "Stokes' Theorem Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Stokes' Theorem Calculator to apply Stokes' theorem for surface integrals and curl calculations.",
  keywords: "Stokes theorem calculator, vector calculus, calculus calculator, math tool, surface integrals, curl theorem"
},
{
  path: "/DivergenceTheoremCalculator",
  component: "DivergenceTheoremCalculator",
  folder: "Calculus",
  title: "Divergence Theorem Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Divergence Theorem Calculator to apply the divergence theorem for volume and surface integrals.",
  keywords: "divergence theorem calculator, Gauss theorem calculator, vector calculus, calculus calculator, math tool, flux integrals"
},
{
  path: "/ComplexAnalysisCalculator",
  component: "ComplexAnalysisCalculator",
  folder: "Calculus",
  title: "Complex Analysis Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Complex Analysis Calculator for complex differentiation, integration, residues, and contour integrals.",
  keywords: "complex analysis calculator, complex integration, residue calculator, calculus calculator, math tool, complex functions"
},


//Statistics
{
  path: "/MeanCalculator",
  component: "MeanCalculator",
  folder: "Statistics",
  title: "Mean Calculator - Calculate Arithmetic Mean | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Mean Calculator to calculate arithmetic mean (average) of data sets. Find sample mean and population mean easily.",
  keywords: "mean calculator, average calculator, arithmetic mean, statistics calculator, math tool, data analysis"
},
{
  path: "/MedianCalculator",
  component: "MedianCalculator",
  folder: "Statistics",
  title: "Median Calculator - Find Median of Data Set | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Median Calculator to find median (middle value) of data sets. Handle even and odd number of data points.",
  keywords: "median calculator, middle value calculator, statistics calculator, math tool, data analysis, central tendency"
},
{
  path: "/ModeCalculator",
  component: "ModeCalculator",
  folder: "Statistics",
  title: "Mode Calculator - Find Mode of Data Set | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Mode Calculator to find mode (most frequent value) in data sets. Identify single and multiple modes.",
  keywords: "mode calculator, most frequent value, statistics calculator, math tool, data analysis, central tendency"
},
{
  path: "/RangeCalculator",
  component: "RangeCalculator",
  folder: "Statistics",
  title: "Range Calculator - Calculate Data Range | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Range Calculator to calculate range of data sets (difference between maximum and minimum values).",
  keywords: "range calculator, data range calculator, statistics calculator, math tool, spread measurement, data analysis"
},
{
  path: "/StandardDeviationCalculator",
  component: "StandardDeviationCalculator",
  folder: "Statistics",
  title: "Standard Deviation Calculator - Calculate SD | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Standard Deviation Calculator to calculate standard deviation of data sets (sample and population).",
  keywords: "standard deviation calculator, SD calculator, statistics calculator, math tool, variance calculator, data analysis"
},
{
  path: "/VarianceCalculator",
  component: "VarianceCalculator",
  folder: "Statistics",
  title: "Variance Calculator - Calculate Data Variance | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Variance Calculator to calculate variance of data sets (sample variance and population variance).",
  keywords: "variance calculator, statistics calculator, math tool, data analysis, spread measurement, statistical variance"
},
{
  path: "/PercentileCalculator",
  component: "PercentileCalculator",
  folder: "Statistics",
  title: "Percentile Calculator - Find Percentiles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Percentile Calculator to find percentiles, deciles, and quartiles in data sets.",
  keywords: "percentile calculator, percentile finder, statistics calculator, math tool, data analysis, quantile calculator"
},
{
  path: "/QuartileCalculator",
  component: "QuartileCalculator",
  folder: "Statistics",
  title: "Quartile Calculator - Calculate Quartiles | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Quartile Calculator to calculate Q1, Q2 (median), and Q3 quartiles of data sets.",
  keywords: "quartile calculator, Q1 Q2 Q3 calculator, statistics calculator, math tool, data analysis, interquartile range"
},
{
  path: "/OutlierDetection",
  component: "OutlierDetection",
  folder: "Statistics",
  title: "Outlier Detection Calculator - Identify Outliers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Outlier Detection Calculator to identify outliers in data sets using IQR method and z-score method.",
  keywords: "outlier detection calculator, outlier finder, statistics calculator, math tool, data analysis, anomaly detection"
},
{
  path: "/InterquartileRangeCalculator",
  component: "InterquartileRangeCalculator",
  folder: "Statistics",
  title: "Interquartile Range Calculator - Calculate IQR | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Interquartile Range Calculator to calculate IQR (difference between Q3 and Q1) of data sets.",
  keywords: "interquartile range calculator, IQR calculator, statistics calculator, math tool, data analysis, spread measurement"
},
{
  path: "/SkewnessCalculator",
  component: "SkewnessCalculator",
  folder: "Statistics",
  title: "Skewness Calculator - Calculate Data Skewness | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Skewness Calculator to calculate skewness coefficient to measure asymmetry of data distribution.",
  keywords: "skewness calculator, asymmetry calculator, statistics calculator, math tool, data analysis, distribution shape"
},
{
  path: "/KurtosisCalculator",
  component: "KurtosisCalculator",
  folder: "Statistics",
  title: "Kurtosis Calculator - Calculate Data Kurtosis | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Kurtosis Calculator to calculate kurtosis coefficient to measure tailedness of data distribution.",
  keywords: "kurtosis calculator, statistics calculator, math tool, data analysis, distribution shape, peakedness calculator"
},
{
  path: "/FiveNumberSummary",
  component: "FiveNumberSummary",
  folder: "Statistics",
  title: "Five Number Summary Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Five Number Summary Calculator to generate minimum, Q1, median, Q3, and maximum of data sets.",
  keywords: "five number summary calculator, statistics calculator, math tool, data analysis, box plot summary, descriptive statistics"
},
{
  path: "/CoefficientOfVariation",
  component: "CoefficientOfVariation",
  folder: "Statistics",
  title: "Coefficient of Variation Calculator - Calculate CV | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Coefficient of Variation Calculator to calculate CV (relative standard deviation) of data sets.",
  keywords: "coefficient of variation calculator, CV calculator, statistics calculator, math tool, data analysis, relative variability"
},
{
  path: "/DataFrequencyTable",
  component: "DataFrequencyTable",
  folder: "Statistics",
  title: "Data Frequency Table Generator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Data Frequency Table Generator to create frequency tables, histograms, and relative frequency tables.",
  keywords: "frequency table generator, data frequency table, statistics calculator, math tool, data analysis, histogram generator"
},
{
  path: "/ProbabilityCalculator",
  component: "ProbabilityCalculator",
  folder: "Statistics",
  title: "Probability Calculator - Calculate Probabilities | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Probability Calculator to calculate basic probabilities, complements, unions, and intersections.",
  keywords: "probability calculator, statistics calculator, math tool, probability theory, chance calculator, event probability"
},
{
  path: "/PermutationCalculator",
  component: "PermutationCalculator",
  folder: "Statistics",
  title: "Permutation Calculator - Calculate Permutations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Permutation Calculator to calculate permutations (nPr) for arrangements and ordered selections.",
  keywords: "permutation calculator, nPr calculator, statistics calculator, math tool, combinatorics, arrangements calculator"
},
{
  path: "/CombinationCalculator",
  component: "CombinationCalculator",
  folder: "Statistics",
  title: "Combination Calculator - Calculate Combinations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Combination Calculator to calculate combinations (nCr) for selections without regard to order.",
  keywords: "combination calculator, nCr calculator, statistics calculator, math tool, combinatorics, selections calculator"
},
{
  path: "/BayesTheoremCalculator",
  component: "BayesTheoremCalculator",
  folder: "Statistics",
  title: "Bayes Theorem Calculator - Bayesian Probability | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Bayes Theorem Calculator to calculate conditional probabilities using Bayes' theorem and rule.",
  keywords: "Bayes theorem calculator, Bayesian probability, statistics calculator, math tool, conditional probability, theorem calculator"
},
{
  path: "/NormalDistributionCalculator",
  component: "NormalDistributionCalculator",
  folder: "Statistics",
  title: "Normal Distribution Calculator - Z-Scores & Probabilities | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Normal Distribution Calculator to calculate probabilities, z-scores, and percentiles for normal distributions.",
  keywords: "normal distribution calculator, Gaussian calculator, statistics calculator, math tool, z-score calculator, probability distribution"
},
{
  path: "/BinomialDistribution",
  component: "BinomialDistribution",
  folder: "Statistics",
  title: "Binomial Distribution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Binomial Distribution Calculator to calculate probabilities for binomial experiments and distributions.",
  keywords: "binomial distribution calculator, statistics calculator, math tool, probability distribution, binomial probability, success probability"
},
{
  path: "/PoissonDistribution",
  component: "PoissonDistribution",
  folder: "Statistics",
  title: "Poisson Distribution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Poisson Distribution Calculator to calculate probabilities for Poisson processes and distributions.",
  keywords: "Poisson distribution calculator, statistics calculator, math tool, probability distribution, Poisson probability, rate calculator"
},
{
  path: "/GeometricDistribution",
  component: "GeometricDistribution",
  folder: "Statistics",
  title: "Geometric Distribution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Geometric Distribution Calculator to calculate probabilities for geometric distributions and trials.",
  keywords: "geometric distribution calculator, statistics calculator, math tool, probability distribution, geometric probability, trial calculator"
},
{
  path: "/HypergeometricDistribution",
  component: "HypergeometricDistribution",
  folder: "Statistics",
  title: "Hypergeometric Distribution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Hypergeometric Distribution Calculator to calculate probabilities for hypergeometric distributions.",
  keywords: "hypergeometric distribution calculator, statistics calculator, math tool, probability distribution, sampling without replacement"
},
{
  path: "/ExponentialDistribution",
  component: "ExponentialDistribution",
  folder: "Statistics",
  title: "Exponential Distribution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Exponential Distribution Calculator to calculate probabilities for exponential distributions and waiting times.",
  keywords: "exponential distribution calculator, statistics calculator, math tool, probability distribution, exponential probability, decay calculator"
},
{
  path: "/DiscreteProbabilityDistribution",
  component: "DiscreteProbabilityDistribution",
  folder: "Statistics",
  title: "Discrete Probability Distribution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Discrete Probability Distribution Calculator to analyze and calculate discrete probability distributions.",
  keywords: "discrete probability distribution calculator, statistics calculator, math tool, probability distribution, discrete random variable"
},
{
  path: "/ContinuousProbabilityDistribution",
  component: "ContinuousProbabilityDistribution",
  folder: "Statistics",
  title: "Continuous Probability Distribution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Continuous Probability Distribution Calculator to analyze and calculate continuous probability distributions.",
  keywords: "continuous probability distribution calculator, statistics calculator, math tool, probability distribution, continuous random variable"
},
{
  path: "/JointProbabilityCalculator",
  component: "JointProbabilityCalculator",
  folder: "Statistics",
  title: "Joint Probability Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Joint Probability Calculator to calculate joint probabilities for multiple events and variables.",
  keywords: "joint probability calculator, statistics calculator, math tool, probability theory, multivariate probability, combined events"
},
{
  path: "/ConditionalProbability",
  component: "ConditionalProbability",
  folder: "Statistics",
  title: "Conditional Probability Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Conditional Probability Calculator to calculate conditional probabilities P(A|B) and related probabilities.",
  keywords: "conditional probability calculator, statistics calculator, math tool, probability theory, given probability, dependent events"
},
{
  path: "/RandomVariableCalculator",
  component: "RandomVariableCalculator",
  folder: "Statistics",
  title: "Random Variable Calculator - Expected Value & Variance | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Random Variable Calculator to calculate expected value (mean), variance, and standard deviation of random variables.",
  keywords: "random variable calculator, expected value calculator, statistics calculator, math tool, probability distribution, variance of RV"
},
{
  path: "/ZScoreCalculator",
  component: "ZScoreCalculator",
  folder: "Statistics",
  title: "Z-Score Calculator - Standard Score Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Z-Score Calculator to calculate z-scores (standard scores) and probabilities for normal distributions.",
  keywords: "z-score calculator, standard score calculator, statistics calculator, math tool, normal distribution, standardization"
},
{
  path: "/PValueCalculator",
  component: "PValueCalculator",
  folder: "Statistics",
  title: "P-Value Calculator - Calculate Statistical Significance | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's P-Value Calculator to calculate p-values for hypothesis testing and statistical significance.",
  keywords: "p-value calculator, statistical significance calculator, statistics calculator, math tool, hypothesis testing, significance level"
},
{
  path: "/TTestCalculator",
  component: "TTestCalculator",
  folder: "Statistics",
  title: "T-Test Calculator - Student's T-Test | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's T-Test Calculator to perform Student's t-tests for means comparison and hypothesis testing.",
  keywords: "t-test calculator, Student's t-test, statistics calculator, math tool, hypothesis testing, mean comparison"
},
{
  path: "/ChiSquareCalculator",
  component: "ChiSquareCalculator",
  folder: "Statistics",
  title: "Chi-Square Calculator - Chi-Square Test | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Chi-Square Calculator to perform chi-square tests for independence, goodness of fit, and homogeneity.",
  keywords: "chi-square calculator, chi-square test, statistics calculator, math tool, hypothesis testing, categorical data"
},
{
  path: "/CorrelationCoefficient",
  component: "CorrelationCoefficient",
  folder: "Statistics",
  title: "Correlation Coefficient Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Correlation Coefficient Calculator to calculate correlation coefficients between variables.",
  keywords: "correlation coefficient calculator, statistics calculator, math tool, correlation analysis, relationship measurement, linear correlation"
},
{
  path: "/RegressionCalculator",
  component: "RegressionCalculator",
  folder: "Statistics",
  title: "Regression Calculator - Linear Regression Analysis | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Regression Calculator to perform linear regression analysis and calculate regression lines.",
  keywords: "regression calculator, linear regression calculator, statistics calculator, math tool, regression analysis, best fit line"
},
{
  path: "/AnovaCalculator",
  component: "AnovaCalculator",
  folder: "Statistics",
  title: "ANOVA Calculator - Analysis of Variance | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's ANOVA Calculator to perform Analysis of Variance tests for comparing multiple group means.",
  keywords: "ANOVA calculator, analysis of variance, statistics calculator, math tool, hypothesis testing, multiple group comparison"
},
{
  path: "/ConfidenceInterval",
  component: "ConfidenceInterval",
  folder: "Statistics",
  title: "Confidence Interval Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Confidence Interval Calculator to calculate confidence intervals for means, proportions, and differences.",
  keywords: "confidence interval calculator, statistics calculator, math tool, interval estimation, margin of error, population parameter"
},
{
  path: "/FTestCalculator",
  component: "FTestCalculator",
  folder: "Statistics",
  title: "F-Test Calculator - F-Distribution Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's F-Test Calculator to perform F-tests for comparing variances and ANOVA applications.",
  keywords: "F-test calculator, F-distribution calculator, statistics calculator, math tool, variance comparison, hypothesis testing"
},
{
  path: "/CovarianceCalculator",
  component: "CovarianceCalculator",
  folder: "Statistics",
  title: "Covariance Calculator - Calculate Covariance | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Covariance Calculator to calculate covariance between two variables and measure joint variability.",
  keywords: "covariance calculator, statistics calculator, math tool, relationship measurement, joint variability, bivariate analysis"
},
{
  path: "/PairedTTestCalculator",
  component: "PairedTTestCalculator",
  folder: "Statistics",
  title: "Paired T-Test Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Paired T-Test Calculator to perform paired sample t-tests for dependent groups and before-after studies.",
  keywords: "paired t-test calculator, dependent t-test, statistics calculator, math tool, hypothesis testing, matched pairs"
},
{
  path: "/OneSampleTTest",
  component: "OneSampleTTest",
  folder: "Statistics",
  title: "One Sample T-Test Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's One Sample T-Test Calculator to perform t-tests comparing sample mean to known population mean.",
  keywords: "one sample t-test calculator, statistics calculator, math tool, hypothesis testing, mean comparison, single sample test"
},
{
  path: "/TwoSampleTTest",
  component: "TwoSampleTTest",
  folder: "Statistics",
  title: "Two Sample T-Test Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Two Sample T-Test Calculator to perform t-tests comparing means of two independent samples.",
  keywords: "two sample t-test calculator, independent t-test, statistics calculator, math tool, hypothesis testing, mean comparison"
},
{
  path: "/SpearmanCorrelationCalculator",
  component: "SpearmanCorrelationCalculator",
  folder: "Statistics",
  title: "Spearman Correlation Calculator - Rank Correlation | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Spearman Correlation Calculator to calculate Spearman's rank correlation coefficient.",
  keywords: "Spearman correlation calculator, rank correlation calculator, statistics calculator, math tool, nonparametric correlation, monotonic relationship"
},
{
  path: "/PearsonCorrelation",
  component: "PearsonCorrelation",
  folder: "Statistics",
  title: "Pearson Correlation Calculator - Linear Correlation | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Pearson Correlation Calculator to calculate Pearson's correlation coefficient for linear relationships.",
  keywords: "Pearson correlation calculator, linear correlation calculator, statistics calculator, math tool, correlation coefficient, relationship measurement"
},


//Financial
{
  path: "/PresentValueCalculator",
  component: "PresentValueCalculator",
  folder: "Financial",
  title: "Present Value Calculator - Calculate PV of Future Cash Flows | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Present Value Calculator to calculate the present value of future cash flows using discount rates. Essential for investment analysis.",
  keywords: "present value calculator, PV calculator, time value of money, finance calculator, investment analysis, discounting calculator"
},
{
  path: "/FutureValueCalculator",
  component: "FutureValueCalculator",
  folder: "Financial",
  title: "Future Value Calculator - Calculate FV of Investments | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Future Value Calculator to calculate future value of investments with compound interest. Plan for financial goals.",
  keywords: "future value calculator, FV calculator, compound interest calculator, finance calculator, investment calculator, savings calculator"
},
{
  path: "/SimpleInterestCalculator",
  component: "SimpleInterestCalculator",
  folder: "Financial",
  title: "Simple Interest Calculator - Calculate Simple Interest | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Simple Interest Calculator to calculate simple interest on loans and investments. Straightforward interest calculation.",
  keywords: "simple interest calculator, interest calculator, finance calculator, loan interest, investment interest, basic interest calculator"
},
{
  path: "/CompoundInterestCalculator",
  component: "CompoundInterestCalculator",
  folder: "Financial",
  title: "Compound Interest Calculator - Calculate Compound Interest | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Compound Interest Calculator to calculate compound interest with various compounding frequencies. Growth calculator.",
  keywords: "compound interest calculator, compounding calculator, finance calculator, investment growth, savings calculator, interest on interest"
},
{
  path: "/ContinuousCompoundingCalculator",
  component: "ContinuousCompoundingCalculator",
  folder: "Financial",
  title: "Continuous Compounding Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Continuous Compounding Calculator to calculate interest compounded continuously using exponential growth formula.",
  keywords: "continuous compounding calculator, finance calculator, exponential growth, investment calculator, e-based compounding, mathematical finance"
},
{
  path: "/DiscountFactorCalculator",
  component: "DiscountFactorCalculator",
  folder: "Financial",
  title: "Discount Factor Calculator - Calculate Present Value Factors | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Discount Factor Calculator to calculate discount factors for present value calculations in financial analysis.",
  keywords: "discount factor calculator, present value factor, finance calculator, time value of money, discounting factor, financial analysis"
},
{
  path: "/AccumulationFactorCalculator",
  component: "AccumulationFactorCalculator",
  folder: "Financial",
  title: "Accumulation Factor Calculator - Calculate Future Value Factors | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Accumulation Factor Calculator to calculate accumulation factors for future value calculations.",
  keywords: "accumulation factor calculator, future value factor, finance calculator, compounding factor, financial mathematics, growth factor"
},
{
  path: "/EffectiveInterestRateCalculator",
  component: "EffectiveInterestRateCalculator",
  folder: "Financial",
  title: "Effective Interest Rate Calculator - Calculate Effective Annual Rate | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Effective Interest Rate Calculator to calculate effective annual rate (EAR) from nominal rates with compounding.",
  keywords: "effective interest rate calculator, EAR calculator, finance calculator, annual percentage yield, APY calculator, effective rate"
},
{
  path: "/NominalInterestRateCalculator",
  component: "NominalInterestRateCalculator",
  folder: "Financial",
  title: "Nominal Interest Rate Calculator - Calculate Nominal Rates | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Nominal Interest Rate Calculator to calculate nominal interest rates from effective rates with compounding periods.",
  keywords: "nominal interest rate calculator, nominal rate calculator, finance calculator, stated rate, APR calculator, interest rate conversion"
},
{
  path: "/InterestConversionCalculator",
  component: "InterestConversionCalculator",
  folder: "Financial",
  title: "Interest Conversion Calculator - Convert Between Rates | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Interest Conversion Calculator to convert between nominal and effective interest rates with different compounding.",
  keywords: "interest conversion calculator, rate converter, finance calculator, APR to APY, effective to nominal, interest rate calculator"
},
{
  path: "/ForceOfInterestCalculator",
  component: "ForceOfInterestCalculator",
  folder: "Financial",
  title: "Force of Interest Calculator - Calculate Delta (δ) | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Force of Interest Calculator to calculate force of interest (instantaneous interest rate) for continuous growth.",
  keywords: "force of interest calculator, delta calculator, finance calculator, continuous interest, mathematical finance, actuarial science"
},
{
  path: "/EquivalentInterestRateCalculator",
  component: "EquivalentInterestRateCalculator",
  folder: "Financial",
  title: "Equivalent Interest Rate Calculator - Find Equivalent Rates | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Equivalent Interest Rate Calculator to find equivalent interest rates with different compounding frequencies.",
  keywords: "equivalent interest rate calculator, finance calculator, rate equivalence, comparable rates, interest rate comparison, financial mathematics"
},
{
  path: "/AccumulatedValueCalculator",
  component: "AccumulatedValueCalculator",
  folder: "Financial",
  title: "Accumulated Value Calculator - Calculate Accumulated Amount | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Accumulated Value Calculator to calculate accumulated value of investments with various interest methods.",
  keywords: "accumulated value calculator, finance calculator, investment growth, compound amount, future value calculator, accumulation calculator"
},
{
  path: "/DiscountRateConversion",
  component: "DiscountRateConversion",
  folder: "Financial",
  title: "Discount Rate Conversion Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Discount Rate Conversion Calculator to convert between different discount rate conventions and methods.",
  keywords: "discount rate conversion calculator, finance calculator, rate converter, present value discount, financial analysis, valuation"
},
{
  path: "/InterestTimePeriodCalculator",
  component: "InterestTimePeriodCalculator",
  folder: "Financial",
  title: "Interest Time Period Calculator - Calculate Time for Growth | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Interest Time Period Calculator to calculate time required to reach financial goals with given interest rates.",
  keywords: "interest time period calculator, time to goal calculator, finance calculator, investment duration, compounding period, growth time"
},
{
  path: "/OrdinaryAnnuityCalculator",
  component: "OrdinaryAnnuityCalculator",
  folder: "Financial",
  title: "Ordinary Annuity Calculator - Calculate Annuity Payments | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Ordinary Annuity Calculator to calculate present and future values of ordinary annuities (payments at end of period).",
  keywords: "ordinary annuity calculator, annuity calculator, finance calculator, retirement planning, payment calculator, financial mathematics"
},
{
  path: "/AnnuityDueCalculator",
  component: "AnnuityDueCalculator",
  folder: "Financial",
  title: "Annuity Due Calculator - Calculate Annuity Due Payments | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Annuity Due Calculator to calculate present and future values of annuities due (payments at beginning of period).",
  keywords: "annuity due calculator, finance calculator, annuity calculator, advance payments, beginning of period, financial mathematics"
},
{
  path: "/PerpetuityCalculator",
  component: "PerpetuityCalculator",
  folder: "Financial",
  title: "Perpetuity Calculator - Calculate Infinite Cash Flows | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Perpetuity Calculator to calculate present value of perpetuities (infinite series of equal payments).",
  keywords: "perpetuity calculator, infinite annuity calculator, finance calculator, perpetual payments, valuation calculator, financial mathematics"
},
{
  path: "/CashFlowPresentValue",
  component: "CashFlowPresentValue",
  folder: "Financial",
  title: "Cash Flow Present Value Calculator - Calculate PV of Multiple Cash Flows | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cash Flow Present Value Calculator to calculate present value of multiple, uneven cash flows.",
  keywords: "cash flow present value calculator, PV of cash flows, finance calculator, investment analysis, uneven payments, financial valuation"
},
{
  path: "/CashFlowFutureValue",
  component: "CashFlowFutureValue",
  folder: "Financial",
  title: "Cash Flow Future Value Calculator - Calculate FV of Multiple Cash Flows | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Cash Flow Future Value Calculator to calculate future value of multiple, uneven cash flows.",
  keywords: "cash flow future value calculator, FV of cash flows, finance calculator, investment analysis, savings plan, financial planning"
},
{
  path: "/GrowingAnnuityCalculator",
  component: "GrowingAnnuityCalculator",
  folder: "Financial",
  title: "Growing Annuity Calculator - Calculate Growing Payments | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Growing Annuity Calculator to calculate present and future values of annuities with growing payments.",
  keywords: "growing annuity calculator, increasing annuity, finance calculator, growth rate payments, inflation-adjusted, financial mathematics"
},
{
  path: "/DeferredAnnuityCalculator",
  component: "DeferredAnnuityCalculator",
  folder: "Financial",
  title: "Deferred Annuity Calculator - Calculate Delayed Annuities | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Deferred Annuity Calculator to calculate values of annuities with deferred start dates.",
  keywords: "deferred annuity calculator, delayed annuity, finance calculator, future annuity, retirement planning, financial mathematics"
},
{
  path: "/AnnuityFactorCalculator",
  component: "AnnuityFactorCalculator",
  folder: "Financial",
  title: "Annuity Factor Calculator - Calculate Annuity Factors | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Annuity Factor Calculator to calculate annuity present value and future value factors.",
  keywords: "annuity factor calculator, finance calculator, financial factors, present value factor, future value factor, mathematical finance"
},
{
  path: "/SinkingFundCalculator",
  component: "SinkingFundCalculator",
  folder: "Financial",
  title: "Sinking Fund Calculator - Calculate Regular Deposits | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Sinking Fund Calculator to calculate regular deposits needed to reach a future savings goal.",
  keywords: "sinking fund calculator, savings calculator, finance calculator, regular deposits, goal planning, financial planning"
},
{
  path: "/CapitalRecoveryFactor",
  component: "CapitalRecoveryFactor",
  folder: "Financial",
  title: "Capital Recovery Factor Calculator - Calculate Loan Payments | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Capital Recovery Factor Calculator to calculate loan payments and capital recovery factors.",
  keywords: "capital recovery factor calculator, loan payment calculator, finance calculator, amortization factor, debt repayment, financial mathematics"
},
{
  path: "/AnnuityPaymentCalculator",
  component: "AnnuityPaymentCalculator",
  folder: "Financial",
  title: "Annuity Payment Calculator - Calculate Periodic Payments | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Annuity Payment Calculator to calculate periodic payments for loans, mortgages, and annuities.",
  keywords: "annuity payment calculator, loan payment calculator, finance calculator, mortgage payment, periodic payments, financial planning"
},
{
  path: "/OutstandingLoanBalanceCalculator",
  component: "OutstandingLoanBalanceCalculator",
  folder: "Financial",
  title: "Outstanding Loan Balance Calculator - Calculate Remaining Balance | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Outstanding Loan Balance Calculator to calculate remaining balance on loans after specified periods.",
  keywords: "outstanding loan balance calculator, remaining balance calculator, finance calculator, loan amortization, debt calculator, mortgage balance"
},
{
  path: "/AmortizationFactorCalculator",
  component: "AmortizationFactorCalculator",
  folder: "Financial",
  title: "Amortization Factor Calculator - Calculate Amortization Factors | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Amortization Factor Calculator to calculate factors for loan amortization and payment calculations.",
  keywords: "amortization factor calculator, finance calculator, loan factors, payment factors, financial mathematics, debt repayment"
},
{
  path: "/GradientAnnuityCalculator",
  component: "GradientAnnuityCalculator",
  folder: "Financial",
  title: "Gradient Annuity Calculator - Calculate Arithmetic Gradient Series | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Gradient Annuity Calculator to calculate present and future values of arithmetic gradient series.",
  keywords: "gradient annuity calculator, arithmetic gradient, finance calculator, increasing payments, financial mathematics, engineering economics"
},
{
  path: "/EquivalentAnnualWorthCalculator",
  component: "EquivalentAnnualWorthCalculator",
  folder: "Financial",
  title: "Equivalent Annual Worth Calculator - Calculate EAW | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Equivalent Annual Worth Calculator to calculate equivalent annual worth for project evaluation.",
  keywords: "equivalent annual worth calculator, EAW calculator, finance calculator, project evaluation, capital budgeting, engineering economics"
},
{
  path: "/NetPresentValueCalculator",
  component: "NetPresentValueCalculator",
  folder: "Financial",
  title: "Net Present Value Calculator - Calculate NPV | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Net Present Value Calculator to calculate NPV for investment projects and capital budgeting decisions.",
  keywords: "net present value calculator, NPV calculator, finance calculator, investment analysis, capital budgeting, project valuation"
},
{
  path: "/InternalRateOfReturnCalculator",
  component: "InternalRateOfReturnCalculator",
  folder: "Financial",
  title: "Internal Rate of Return Calculator - Calculate IRR | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Internal Rate of Return Calculator to calculate IRR for investment projects and rate of return analysis.",
  keywords: "internal rate of return calculator, IRR calculator, finance calculator, investment analysis, rate of return, project evaluation"
},
{
  path: "/ModifiedIRRCalculator",
  component: "ModifiedIRRCalculator",
  folder: "Financial",
  title: "Modified IRR Calculator - Calculate MIRR | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Modified IRR Calculator to calculate Modified Internal Rate of Return for more realistic investment analysis.",
  keywords: "modified IRR calculator, MIRR calculator, finance calculator, investment analysis, capital budgeting, project evaluation"
},
{
  path: "/DiscountRateCalculator",
  component: "DiscountRateCalculator",
  folder: "Financial",
  title: "Discount Rate Calculator - Calculate Required Rate | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Discount Rate Calculator to calculate appropriate discount rates for investment valuation.",
  keywords: "discount rate calculator, required rate calculator, finance calculator, investment valuation, cost of capital, hurdle rate"
},
{
  path: "/YieldToMaturityCalculator",
  component: "YieldToMaturityCalculator",
  folder: "Financial",
  title: "Yield to Maturity Calculator - Calculate YTM | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Yield to Maturity Calculator to calculate YTM for bonds and fixed income securities.",
  keywords: "yield to maturity calculator, YTM calculator, finance calculator, bond calculator, fixed income, investment analysis"
},
{
  path: "/BondPriceCalculator",
  component: "BondPriceCalculator",
  folder: "Financial",
  title: "Bond Price Calculator - Calculate Bond Valuation | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Bond Price Calculator to calculate fair price of bonds based on coupon, yield, and maturity.",
  keywords: "bond price calculator, bond valuation calculator, finance calculator, fixed income, bond pricing, investment analysis"
},
{
  path: "/BondDurationCalculator",
  component: "BondDurationCalculator",
  folder: "Financial",
  title: "Bond Duration Calculator - Calculate Macaulay & Modified Duration | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Bond Duration Calculator to calculate Macaulay duration and modified duration for bond price sensitivity.",
  keywords: "bond duration calculator, Macaulay duration, modified duration, finance calculator, bond risk, interest rate sensitivity"
},
{
  path: "/BondConvexityCalculator",
  component: "BondConvexityCalculator",
  folder: "Financial",
  title: "Bond Convexity Calculator - Calculate Bond Convexity | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Bond Convexity Calculator to calculate convexity for more accurate bond price change estimation.",
  keywords: "bond convexity calculator, finance calculator, bond risk, duration and convexity, fixed income analysis, interest rate risk"
},
{
  path: "/PaybackPeriodCalculator",
  component: "PaybackPeriodCalculator",
  folder: "Financial",
  title: "Payback Period Calculator - Calculate Investment Recovery Time | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Payback Period Calculator to calculate time required to recover initial investment.",
  keywords: "payback period calculator, investment recovery calculator, finance calculator, capital budgeting, project evaluation, break-even time"
},
{
  path: "/ProfitabilityIndexCalculator",
  component: "ProfitabilityIndexCalculator",
  folder: "Financial",
  title: "Profitability Index Calculator - Calculate PI | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Profitability Index Calculator to calculate PI (benefit-cost ratio) for investment projects.",
  keywords: "profitability index calculator, PI calculator, finance calculator, investment analysis, capital budgeting, benefit-cost ratio"
},
{
  path: "/HoldingPeriodReturnCalculator",
  component: "HoldingPeriodReturnCalculator",
  folder: "Financial",
  title: "Holding Period Return Calculator - Calculate HPR | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Holding Period Return Calculator to calculate total return over specific holding periods.",
  keywords: "holding period return calculator, HPR calculator, finance calculator, investment return, total return, performance measurement"
},
{
  path: "/SpotRateCalculator",
  component: "SpotRateCalculator",
  folder: "Financial",
  title: "Spot Rate Calculator - Calculate Spot Interest Rates | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Spot Rate Calculator to calculate spot rates from bond prices and yield curve construction.",
  keywords: "spot rate calculator, zero rate calculator, finance calculator, yield curve, fixed income, interest rate calculation"
},
{
  path: "/ForwardRateCalculator",
  component: "ForwardRateCalculator",
  folder: "Financial",
  title: "Forward Rate Calculator - Calculate Forward Interest Rates | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Forward Rate Calculator to calculate forward rates from spot rates for future periods.",
  keywords: "forward rate calculator, implied forward rate, finance calculator, interest rate forecasting, yield curve, fixed income"
},
{
  path: "/ZeroCouponBondCalculator",
  component: "ZeroCouponBondCalculator",
  folder: "Financial",
  title: "Zero Coupon Bond Calculator - Calculate ZCB Prices & Yields | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Zero Coupon Bond Calculator to calculate prices and yields of zero coupon bonds.",
  keywords: "zero coupon bond calculator, ZCB calculator, finance calculator, discount bonds, fixed income, investment analysis"
},
{
  path: "/CapitalAssetPricingModelCalculator",
  component: "CapitalAssetPricingModelCalculator",
  folder: "Financial",
  title: "CAPM Calculator - Capital Asset Pricing Model | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's CAPM Calculator to calculate expected returns using Capital Asset Pricing Model.",
  keywords: "CAPM calculator, capital asset pricing model calculator, finance calculator, expected return, beta calculation, investment theory"
},


//Converters
{
  path: "/LengthConverter",
  component: "LengthConverter",
  folder: "Converters",
  title: "Length Converter - Convert Length Units Online | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Length Converter to convert between meters, feet, inches, miles, kilometers, centimeters, and other length units.",
  keywords: "length converter, unit converter, measurement converter, metric to imperial, feet to meters, inches to cm, distance converter"
},
{
  path: "/WeightConverter",
  component: "WeightConverter",
  folder: "Converters",
  title: "Weight Converter - Convert Weight/Mass Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Weight Converter to convert between kilograms, pounds, ounces, grams, tons, stones, and other weight units.",
  keywords: "weight converter, mass converter, unit converter, kg to pounds, pounds to kg, ounces to grams, measurement converter"
},
{
  path: "/TemperatureConverter",
  component: "TemperatureConverter",
  folder: "Converters",
  title: "Temperature Converter - Convert Temperature Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Temperature Converter to convert between Celsius, Fahrenheit, Kelvin, and Rankine temperature scales.",
  keywords: "temperature converter, unit converter, Celsius to Fahrenheit, Fahrenheit to Celsius, Kelvin converter, temperature scale converter"
},
{
  path: "/AreaConverter",
  component: "AreaConverter",
  folder: "Converters",
  title: "Area Converter - Convert Area Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Area Converter to convert between square meters, square feet, acres, hectares, square miles, and other area units.",
  keywords: "area converter, unit converter, square meters to square feet, acres to hectares, land measurement, area measurement converter"
},
{
  path: "/VolumeConverter",
  component: "VolumeConverter",
  folder: "Converters",
  title: "Volume Converter - Convert Volume Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Volume Converter to convert between liters, gallons, cubic meters, cubic feet, milliliters, and other volume units.",
  keywords: "volume converter, unit converter, liters to gallons, gallons to liters, cubic meters converter, liquid measurement converter"
},
{
  path: "/SpeedConverter",
  component: "SpeedConverter",
  folder: "Converters",
  title: "Speed Converter - Convert Speed Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Speed Converter to convert between kilometers per hour, miles per hour, meters per second, knots, and other speed units.",
  keywords: "speed converter, unit converter, km/h to mph, mph to km/h, knots converter, velocity converter, speed measurement"
},
{
  path: "/TimeConverter",
  component: "TimeConverter",
  folder: "Converters",
  title: "Time Converter - Convert Time Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Time Converter to convert between seconds, minutes, hours, days, weeks, months, years, and other time units.",
  keywords: "time converter, unit converter, time measurement, seconds to minutes, hours to days, time unit calculator, duration converter"
},
{
  path: "/PressureConverter",
  component: "PressureConverter",
  folder: "Converters",
  title: "Pressure Converter - Convert Pressure Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Pressure Converter to convert between Pascals, atmospheres, bars, psi, torr, mmHg, and other pressure units.",
  keywords: "pressure converter, unit converter, psi to bar, atmospheres to Pascals, pressure measurement, force per area converter"
},
{
  path: "/EnergyConverter",
  component: "EnergyConverter",
  folder: "Converters",
  title: "Energy Converter - Convert Energy Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Energy Converter to convert between joules, calories, kilowatt-hours, electronvolts, BTUs, and other energy units.",
  keywords: "energy converter, unit converter, joules to calories, kWh to joules, BTU converter, energy measurement, work converter"
},
{
  path: "/PowerConverter",
  component: "PowerConverter",
  folder: "Converters",
  title: "Power Converter - Convert Power Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Power Converter to convert between watts, kilowatts, horsepower, BTUs per hour, and other power units.",
  keywords: "power converter, unit converter, watts to horsepower, kW to hp, power measurement, energy rate converter, electrical power"
},
{
  path: "/ForceConverter",
  component: "ForceConverter",
  folder: "Converters",
  title: "Force Converter - Convert Force Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Force Converter to convert between newtons, pounds-force, dynes, kilogram-force, and other force units.",
  keywords: "force converter, unit converter, newtons to pounds-force, force measurement, physics converter, mechanical force converter"
},
{
  path: "/DensityConverter",
  component: "DensityConverter",
  folder: "Converters",
  title: "Density Converter - Convert Density Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Density Converter to convert between kg/m³, g/cm³, lb/ft³, lb/in³, and other density units.",
  keywords: "density converter, unit converter, kg/m3 to g/cm3, density measurement, mass per volume, material density converter"
},
{
  path: "/AngleConverter",
  component: "AngleConverter",
  folder: "Converters",
  title: "Angle Converter - Convert Angle Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Angle Converter to convert between degrees, radians, gradians, minutes, seconds, and other angle units.",
  keywords: "angle converter, unit converter, degrees to radians, radians to degrees, angle measurement, geometry converter, circular measure"
},
{
  path: "/FrequencyConverter",
  component: "FrequencyConverter",
  folder: "Converters",
  title: "Frequency Converter - Convert Frequency Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Frequency Converter to convert between hertz, kilohertz, megahertz, gigahertz, rpm, and other frequency units.",
  keywords: "frequency converter, unit converter, hertz to kilohertz, MHz to GHz, frequency measurement, wave frequency, rotation frequency"
},
{
  path: "/TorqueConverter",
  component: "TorqueConverter",
  folder: "Converters",
  title: "Torque Converter - Convert Torque Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Torque Converter to convert between newton-meters, pound-feet, kilogram-meters, and other torque units.",
  keywords: "torque converter, unit converter, Nm to lb-ft, torque measurement, rotational force, mechanical torque, engineering converter"
},
{
  path: "/FuelEfficiencyConverter",
  component: "FuelEfficiencyConverter",
  folder: "Converters",
  title: "Fuel Efficiency Converter - Convert MPG, L/100km | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Fuel Efficiency Converter to convert between miles per gallon, liters per 100km, km per liter, and other fuel economy units.",
  keywords: "fuel efficiency converter, MPG converter, L/100km converter, fuel economy, gas mileage converter, automotive converter"
},
{
  path: "/SoundLevelConverter",
  component: "SoundLevelConverter",
  folder: "Converters",
  title: "Sound Level Converter - Convert Decibels | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Sound Level Converter to convert between sound pressure levels, decibels, and other acoustic measurement units.",
  keywords: "sound level converter, decibel converter, dB converter, sound pressure level, acoustic measurement, noise level converter"
},
{
  path: "/IlluminationConverter",
  component: "IlluminationConverter",
  folder: "Converters",
  title: "Illumination Converter - Convert Light Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Illumination Converter to convert between lux, lumens, candela, foot-candles, and other lighting units.",
  keywords: "illumination converter, light converter, lux to lumens, candela converter, lighting measurement, photometry converter"
},
{
  path: "/MagneticFieldConverter",
  component: "MagneticFieldConverter",
  folder: "Converters",
  title: "Magnetic Field Converter - Convert Magnetic Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Magnetic Field Converter to convert between tesla, gauss, webers, and other magnetic field units.",
  keywords: "magnetic field converter, unit converter, tesla to gauss, magnetic measurement, electromagnetic converter, physics converter"
},
{
  path: "/ViscosityConverter",
  component: "ViscosityConverter",
  folder: "Converters",
  title: "Viscosity Converter - Convert Viscosity Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Viscosity Converter to convert between Pascal-seconds, poise, centipoise, and other viscosity units.",
  keywords: "viscosity converter, unit converter, Pascal-seconds to poise, viscosity measurement, fluid dynamics, rheology converter"
},
{
  path: "/DataStorageConverter",
  component: "DataStorageConverter",
  folder: "Converters",
  title: "Data Storage Converter - Convert Digital Storage Units | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Data Storage Converter to convert between bytes, kilobytes, megabytes, gigabytes, terabytes, and other digital storage units.",
  keywords: "data storage converter, digital storage converter, bytes to MB, GB to TB, computer storage, memory converter, file size converter"
},
{
  path: "/BaseNumberConverter",
  component: "BaseNumberConverter",
  folder: "Converters",
  title: "Base Number Converter - Convert Between Number Bases | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Base Number Converter to convert numbers between different bases (binary, decimal, hexadecimal, octal).",
  keywords: "base number converter, number base converter, base converter, binary decimal hexadecimal, numeral system converter, radix converter"
},
{
  path: "/BinaryCalculator",
  component: "BinaryCalculator",
  folder: "Converters",
  title: "Binary Calculator - Calculate with Binary Numbers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Binary Calculator to perform arithmetic operations (addition, subtraction, multiplication, division) with binary numbers.",
  keywords: "binary calculator, binary arithmetic, binary operations, binary addition, binary subtraction, computer arithmetic, digital calculator"
},
{
  path: "/HexadecimalCalculator",
  component: "HexadecimalCalculator",
  folder: "Converters",
  title: "Hexadecimal Calculator - Calculate with Hex Numbers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Hexadecimal Calculator to perform arithmetic operations with hexadecimal numbers.",
  keywords: "hexadecimal calculator, hex calculator, base-16 calculator, hex arithmetic, computer science calculator, programming calculator"
},
{
  path: "/RomanNumeralConverter",
  component: "RomanNumeralConverter",
  folder: "Converters",
  title: "Roman Numeral Converter - Convert to/from Roman Numerals | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Roman Numeral Converter to convert between Arabic numbers and Roman numerals (I, V, X, L, C, D, M).",
  keywords: "Roman numeral converter, Roman numbers converter, Roman to Arabic, Arabic to Roman, numeral converter, ancient numbers"
},
{
  path: "/OctalCalculator",
  component: "OctalCalculator",
  folder: "Converters",
  title: "Octal Calculator - Calculate with Octal Numbers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Octal Calculator to perform arithmetic operations with octal (base-8) numbers.",
  keywords: "octal calculator, base-8 calculator, octal arithmetic, computer science calculator, programming calculator, octal operations"
},
{
  path: "/DecimalToBinaryConverter",
  component: "DecimalToBinaryConverter",
  folder: "Converters",
  title: "Decimal to Binary Converter - Convert Decimal to Binary | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Decimal to Binary Converter to convert decimal numbers to binary format quickly and accurately.",
  keywords: "decimal to binary converter, base-10 to base-2, decimal binary conversion, number converter, computer science tool"
},
{
  path: "/DecimalToHexadecimalConverter",
  component: "DecimalToHexadecimalConverter",
  folder: "Converters",
  title: "Decimal to Hexadecimal Converter - Convert Decimal to Hex | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Decimal to Hexadecimal Converter to convert decimal numbers to hexadecimal format.",
  keywords: "decimal to hexadecimal converter, decimal to hex converter, base-10 to base-16, number converter, programming converter"
},
{
  path: "/BinaryToDecimalConverter",
  component: "BinaryToDecimalConverter",
  folder: "Converters",
  title: "Binary to Decimal Converter - Convert Binary to Decimal | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Binary to Decimal Converter to convert binary numbers to decimal format.",
  keywords: "binary to decimal converter, binary to base-10 converter, binary conversion, computer science tool, digital converter"
},
{
  path: "/HexadecimalToDecimalConverter",
  component: "HexadecimalToDecimalConverter",
  folder: "Converters",
  title: "Hexadecimal to Decimal Converter - Convert Hex to Decimal | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Hexadecimal to Decimal Converter to convert hexadecimal numbers to decimal format.",
  keywords: "hexadecimal to decimal converter, hex to decimal converter, base-16 to base-10, number converter, programming tool"
},
{
  path: "/BinaryToHexadecimalConverter",
  component: "BinaryToHexadecimalConverter",
  folder: "Converters",
  title: "Binary to Hexadecimal Converter - Convert Binary to Hex | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Binary to Hexadecimal Converter to convert binary numbers directly to hexadecimal format.",
  keywords: "binary to hexadecimal converter, binary to hex converter, base-2 to base-16, direct conversion, computer science tool"
},
{
  path: "/HexadecimalToBinaryConverter",
  component: "HexadecimalToBinaryConverter",
  folder: "Converters",
  title: "Hexadecimal to Binary Converter - Convert Hex to Binary | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Hexadecimal to Binary Converter to convert hexadecimal numbers directly to binary format.",
  keywords: "hexadecimal to binary converter, hex to binary converter, base-16 to base-2, direct conversion, programming tool"
},
{
  path: "/BinaryToOctalConverter",
  component: "BinaryToOctalConverter",
  folder: "Converters",
  title: "Binary to Octal Converter - Convert Binary to Octal | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Binary to Octal Converter to convert binary numbers directly to octal format.",
  keywords: "binary to octal converter, binary to base-8 converter, base-2 to base-8, direct conversion, computer science tool"
},
{
  path: "/OctalToBinaryConverter",
  component: "OctalToBinaryConverter",
  folder: "Converters",
  title: "Octal to Binary Converter - Convert Octal to Binary | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Octal to Binary Converter to convert octal numbers directly to binary format.",
  keywords: "octal to binary converter, base-8 to base-2 converter, octal conversion, computer science tool, programming converter"
},
{
  path: "/OctalToDecimalConverter",
  component: "OctalToDecimalConverter",
  folder: "Converters",
  title: "Octal to Decimal Converter - Convert Octal to Decimal | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Octal to Decimal Converter to convert octal numbers to decimal format.",
  keywords: "octal to decimal converter, base-8 to base-10 converter, octal conversion, number converter, computer science tool"
},
{
  path: "/DecimalToOctalConverter",
  component: "DecimalToOctalConverter",
  folder: "Converters",
  title: "Decimal to Octal Converter - Convert Decimal to Octal | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Decimal to Octal Converter to convert decimal numbers to octal format.",
  keywords: "decimal to octal converter, base-10 to base-8 converter, decimal conversion, number converter, programming tool"
},
{
  path: "/NumberSystemCalculator",
  component: "NumberSystemCalculator",
  folder: "Converters",
  title: "Number System Calculator - Convert Between All Bases | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Number System Calculator to convert between binary, decimal, hexadecimal, octal, and other number systems.",
  keywords: "number system calculator, numeral system calculator, base converter, all-in-one converter, computer science calculator, programming tool"
},
{
  path: "/BitwiseCalculator",
  component: "BitwiseCalculator",
  folder: "Converters",
  title: "Bitwise Calculator - Bitwise Operations Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Bitwise Calculator to perform bitwise operations (AND, OR, XOR, NOT, shift left, shift right) on binary numbers.",
  keywords: "bitwise calculator, bitwise operations, AND OR XOR NOT, bit shift calculator, binary operations, programming calculator, computer science tool"
},
{
  path: "/ASCIIConverter",
  component: "ASCIIConverter",
  folder: "Converters",
  title: "ASCII Converter - Convert to/from ASCII Codes | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's ASCII Converter to convert between characters and ASCII codes (decimal, hexadecimal, binary).",
  keywords: "ASCII converter, ASCII code converter, character to ASCII, ASCII table, text to ASCII, programming tool, computer science"
},
{
  path: "/UnicodeConverter",
  component: "UnicodeConverter",
  folder: "Converters",
  title: "Unicode Converter - Convert Unicode Characters & Codes | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Unicode Converter to convert between Unicode characters and their code points (UTF-8, UTF-16, UTF-32).",
  keywords: "Unicode converter, Unicode code point converter, UTF-8 converter, UTF-16 converter, character encoding, international text converter"
},


//Advanced Math
{
  path: "/FibonacciCalculator",
  component: "FibonacciCalculator",
  folder: "AdvancedMath",
  title: "Fibonacci Calculator - Generate Fibonacci Sequence | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Fibonacci Calculator to generate Fibonacci numbers, calculate golden ratio, and explore Fibonacci sequence properties.",
  keywords: "Fibonacci calculator, Fibonacci sequence, golden ratio, Fibonacci numbers, number sequence, mathematical sequence"
},
{
  path: "/FactorialCalculator",
  component: "FactorialCalculator",
  folder: "AdvancedMath",
  title: "Factorial Calculator - Calculate Factorials (n!) | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Factorial Calculator to calculate factorials, double factorials, and permutations. Supports large number calculations.",
  keywords: "factorial calculator, n factorial, permutation calculator, combinatorial calculator, advanced math, mathematical functions"
},
{
  path: "/PrimeCountingFunction",
  component: "PrimeCountingFunction",
  folder: "AdvancedMath",
  title: "Prime Counting Function Calculator - π(x) Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Prime Counting Function Calculator to calculate π(x) - number of primes less than or equal to x.",
  keywords: "prime counting function calculator, pi(x) calculator, prime number distribution, advanced mathematics, number theory, prime calculator"
},
{
  path: "/PrimeFactorizationCalculator",
  component: "PrimeFactorizationCalculator",
  folder: "AdvancedMath",
  title: "Prime Factorization Calculator - Factor Numbers into Primes | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Prime Factorization Calculator to factor numbers into prime factors and create factor trees.",
  keywords: "prime factorization calculator, prime factors, factor tree, number factorization, advanced math, cryptography tool"
},
{
  path: "/ModularArithmeticCalculator",
  component: "ModularArithmeticCalculator",
  folder: "AdvancedMath",
  title: "Modular Arithmetic Calculator - Modulo Operations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Modular Arithmetic Calculator to perform modulo operations, modular exponentiation, and solve congruences.",
  keywords: "modular arithmetic calculator, modulo calculator, congruence solver, modular mathematics, cryptography, number theory"
},
{
  path: "/ContinuedFractionCalculator",
  component: "ContinuedFractionCalculator",
  folder: "AdvancedMath",
  title: "Continued Fraction Calculator - Calculate Continued Fractions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Continued Fraction Calculator to convert numbers to continued fractions and calculate convergents.",
  keywords: "continued fraction calculator, mathematical fractions, approximation calculator, number theory, advanced mathematics, rational approximation"
},
{
  path: "/GaloisFieldCalculator",
  component: "GaloisFieldCalculator",
  folder: "AdvancedMath",
  title: "Galois Field Calculator - GF(p^n) Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Galois Field Calculator to perform operations in finite fields (Galois fields) used in coding theory and cryptography.",
  keywords: "Galois field calculator, finite field calculator, GF calculator, advanced algebra, cryptography, coding theory"
},
{
  path: "/CollatzSequenceCalculator",
  component: "CollatzSequenceCalculator",
  folder: "AdvancedMath",
  title: "Collatz Sequence Calculator - 3n+1 Problem Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Collatz Sequence Calculator to generate Collatz sequences and explore the Collatz conjecture (3n+1 problem).",
  keywords: "Collatz sequence calculator, 3n+1 problem, Collatz conjecture, mathematical sequence, unsolved problem, number theory"
},
{
  path: "/SequencePatternCalculator",
  component: "SequencePatternCalculator",
  folder: "AdvancedMath",
  title: "Sequence Pattern Calculator - Find Sequence Formulas | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Sequence Pattern Calculator to detect patterns in number sequences and find generating formulas.",
  keywords: "sequence pattern calculator, pattern detector, sequence formula finder, mathematical sequences, pattern recognition, advanced mathematics"
},
{
  path: "/NumberBasePatternDetector",
  component: "NumberBasePatternDetector",
  folder: "AdvancedMath",
  title: "Number Base Pattern Detector - Analyze Patterns in Different Bases | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Number Base Pattern Detector to analyze number patterns across different numeral systems and bases.",
  keywords: "number base pattern detector, numeral system patterns, base analysis, mathematical patterns, number theory, advanced mathematics"
},
{
  path: "/LucasNumbersCalculator",
  component: "LucasNumbersCalculator",
  folder: "AdvancedMath",
  title: "Lucas Numbers Calculator - Generate Lucas Sequence | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Lucas Numbers Calculator to generate Lucas numbers and explore their relationship with Fibonacci numbers.",
  keywords: "Lucas numbers calculator, Lucas sequence, mathematical sequence, Fibonacci relation, number theory, advanced mathematics"
},
{
  path: "/BernoulliNumbersCalculator",
  component: "BernoulliNumbersCalculator",
  folder: "AdvancedMath",
  title: "Bernoulli Numbers Calculator - Calculate Bernoulli Numbers | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Bernoulli Numbers Calculator to calculate Bernoulli numbers used in number theory and calculus.",
  keywords: "Bernoulli numbers calculator, advanced mathematics, number theory, special numbers, mathematical constants, calculus applications"
},
{
  path: "/EulerTotientFunction",
  component: "EulerTotientFunction",
  folder: "AdvancedMath",
  title: "Euler Totient Function Calculator - φ(n) Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Euler Totient Function Calculator to calculate φ(n) - number of integers coprime to n.",
  keywords: "Euler totient function calculator, phi(n) calculator, number theory, cryptography, RSA algorithm, advanced mathematics"
},
{
  path: "/PartitionFunctionCalculator",
  component: "PartitionFunctionCalculator",
  folder: "AdvancedMath",
  title: "Partition Function Calculator - Calculate Integer Partitions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Partition Function Calculator to calculate the number of ways to partition an integer into sums.",
  keywords: "partition function calculator, integer partitions, combinatorial mathematics, number theory, advanced math, partition numbers"
},
{
  path: "/MobiusFunctionCalculator",
  component: "MobiusFunctionCalculator",
  folder: "AdvancedMath",
  title: "Möbius Function Calculator - μ(n) Calculator | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Möbius Function Calculator to calculate μ(n) values used in number theory and Möbius inversion.",
  keywords: "Möbius function calculator, mu(n) calculator, number theory, advanced mathematics, Möbius inversion, arithmetic functions"
},
{
  path: "/FourierTransformCalculator",
  component: "FourierTransformCalculator",
  folder: "AdvancedMath",
  title: "Fourier Transform Calculator - Calculate Fourier Transforms | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Fourier Transform Calculator to compute Fourier transforms for signal processing and mathematical analysis.",
  keywords: "Fourier transform calculator, frequency analysis, signal processing, advanced mathematics, engineering math, transform calculator"
},
{
  path: "/ProbabilityDensityFunctionViewer",
  component: "ProbabilityDensityFunctionViewer",
  folder: "AdvancedMath",
  title: "Probability Density Function Viewer - Visualize PDFs | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Probability Density Function Viewer to visualize and analyze probability density functions for various distributions.",
  keywords: "probability density function viewer, PDF visualizer, statistical distributions, probability visualization, advanced statistics, math graphics"
},
{
  path: "/CombinatorialSumCalculator",
  component: "CombinatorialSumCalculator",
  folder: "AdvancedMath",
  title: "Combinatorial Sum Calculator - Calculate Combinatorial Sums | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Combinatorial Sum Calculator to calculate combinatorial sums, binomial sums, and combinatorial identities.",
  keywords: "combinatorial sum calculator, binomial sums, combinatorial mathematics, advanced algebra, summation calculator, mathematical sums"
},
{
  path: "/RandomMatrixGenerator",
  component: "RandomMatrixGenerator",
  folder: "AdvancedMath",
  title: "Random Matrix Generator - Generate Random Matrices | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Random Matrix Generator to create random matrices with various distributions and properties.",
  keywords: "random matrix generator, matrix calculator, linear algebra, probability matrices, advanced mathematics, statistical matrices"
},
{
  path: "/LinearProgrammingSolver",
  component: "LinearProgrammingSolver",
  folder: "AdvancedMath",
  title: "Linear Programming Solver - Solve LP Problems | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Linear Programming Solver to solve linear programming problems with constraints and objective functions.",
  keywords: "linear programming solver, LP solver, optimization calculator, operations research, advanced mathematics, simplex method"
},
{
  path: "/OptimizationCalculator",
  component: "OptimizationCalculator",
  folder: "AdvancedMath",
  title: "Optimization Calculator - Mathematical Optimization | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Optimization Calculator to solve optimization problems with constraints and multiple variables.",
  keywords: "optimization calculator, mathematical optimization, constraint solver, advanced mathematics, operations research, optimization problems"
},
{
  path: "/StepFunctionCalculator",
  component: "StepFunctionCalculator",
  folder: "AdvancedMath",
  title: "Step Function Calculator - Calculate Step Functions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Step Function Calculator to create and analyze step functions (Heaviside functions) and piecewise constant functions.",
  keywords: "step function calculator, Heaviside function, piecewise functions, advanced mathematics, mathematical functions, signal processing"
},
{
  path: "/HashCalculator",
  component: "HashCalculator",
  folder: "AdvancedMath",
  title: "Hash Calculator - Calculate Cryptographic Hashes | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Hash Calculator to compute cryptographic hash functions like MD5, SHA-1, SHA-256, and others.",
  keywords: "hash calculator, cryptographic hash, MD5 calculator, SHA calculator, security tool, computer science, cryptography"
},
{
  path: "/ZTransformCalculator",
  component: "ZTransformCalculator",
  folder: "AdvancedMath",
  title: "Z-Transform Calculator - Calculate Z-Transforms | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Z-Transform Calculator to compute Z-transforms for discrete-time signal processing and control systems.",
  keywords: "Z-transform calculator, discrete transform, signal processing, control systems, advanced mathematics, engineering math"
},
{
  path: "/InverseZTransformCalculator",
  component: "InverseZTransformCalculator",
  folder: "AdvancedMath",
  title: "Inverse Z-Transform Calculator - Calculate Inverse Z-Transforms | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Inverse Z-Transform Calculator to compute inverse Z-transforms for discrete-time systems analysis.",
  keywords: "inverse Z-transform calculator, discrete systems, signal processing, control theory, advanced mathematics, engineering calculator"
},
{
  path: "/WaveletTransformCalculator",
  component: "WaveletTransformCalculator",
  folder: "AdvancedMath",
  title: "Wavelet Transform Calculator - Calculate Wavelet Transforms | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Wavelet Transform Calculator to compute wavelet transforms for multi-resolution signal analysis.",
  keywords: "wavelet transform calculator, signal analysis, multi-resolution analysis, advanced mathematics, image processing, engineering tool"
},
{
  path: "/DiscreteCosineTransformCalculator",
  component: "DiscreteCosineTransformCalculator",
  folder: "AdvancedMath",
  title: "Discrete Cosine Transform Calculator - Calculate DCT | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Discrete Cosine Transform Calculator to compute DCT for image and signal compression applications.",
  keywords: "discrete cosine transform calculator, DCT calculator, image compression, signal processing, advanced mathematics, engineering tool"
},
{
  path: "/SingularValueDecompositionCalculator",
  component: "SingularValueDecompositionCalculator",
  folder: "AdvancedMath",
  title: "Singular Value Decomposition Calculator - Calculate SVD | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Singular Value Decomposition Calculator to compute SVD for matrix factorization and dimensionality reduction.",
  keywords: "singular value decomposition calculator, SVD calculator, matrix factorization, linear algebra, advanced mathematics, data science"
},
{
  path: "/MarkovChainCalculator",
  component: "MarkovChainCalculator",
  folder: "AdvancedMath",
  title: "Markov Chain Calculator - Analyze Markov Chains | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Markov Chain Calculator to analyze Markov chains, transition matrices, and steady-state probabilities.",
  keywords: "Markov chain calculator, stochastic processes, probability matrices, advanced statistics, mathematical modeling, state transitions"
},
{
  path: "/NumericalIntegrationCalculator",
  component: "NumericalIntegrationCalculator",
  folder: "AdvancedMath",
  title: "Numerical Integration Calculator - Approximate Integrals | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Numerical Integration Calculator to approximate integrals using various numerical methods (Simpson's, Trapezoidal, etc.).",
  keywords: "numerical integration calculator, integral approximation, Simpson's rule, trapezoidal rule, advanced calculus, numerical analysis"
},
{
  path: "/GraphPlotter",
  component: "GraphPlotter",
  folder: "AdvancedMath",
  title: "Graph Plotter - Plot Mathematical Functions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Graph Plotter to visualize mathematical functions, equations, and data with customizable graphing options.",
  keywords: "graph plotter, function plotter, mathematical graphing, visualization tool, advanced mathematics, graphing calculator"
},
{
  path: "/LogarithmicRegressionCalculator",
  component: "LogarithmicRegressionCalculator",
  folder: "AdvancedMath",
  title: "Logarithmic Regression Calculator - Fit Logarithmic Models | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Logarithmic Regression Calculator to fit logarithmic models to data and analyze logarithmic relationships.",
  keywords: "logarithmic regression calculator, curve fitting, logarithmic models, data analysis, advanced statistics, mathematical modeling"
},
{
  path: "/ExponentialRegressionCalculator",
  component: "ExponentialRegressionCalculator",
  folder: "AdvancedMath",
  title: "Exponential Regression Calculator - Fit Exponential Models | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Exponential Regression Calculator to fit exponential models to data and analyze exponential growth/decay.",
  keywords: "exponential regression calculator, growth models, decay models, curve fitting, advanced statistics, mathematical modeling"
},
{
  path: "/LinearRegressionCalculator",
  component: "LinearRegressionCalculator",
  folder: "AdvancedMath",
  title: "Linear Regression Calculator - Fit Linear Models | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Linear Regression Calculator to perform linear regression analysis and fit best-fit lines to data.",
  keywords: "linear regression calculator, best fit line, regression analysis, statistical modeling, advanced mathematics, data analysis"
},
{
  path: "/PolynomialRegressionCalculator",
  component: "PolynomialRegressionCalculator",
  folder: "AdvancedMath",
  title: "Polynomial Regression Calculator - Fit Polynomial Models | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Polynomial Regression Calculator to fit polynomial models of various degrees to data.",
  keywords: "polynomial regression calculator, curve fitting, polynomial models, advanced statistics, mathematical modeling, data analysis"
},
{
  path: "/MultipleRegressionCalculator",
  component: "MultipleRegressionCalculator",
  folder: "AdvancedMath",
  title: "Multiple Regression Calculator - Fit Multivariate Models | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Multiple Regression Calculator to perform multiple regression analysis with multiple independent variables.",
  keywords: "multiple regression calculator, multivariate analysis, statistical modeling, advanced statistics, data analysis, regression analysis"
},
{
  path: "/LogisticRegressionCalculator",
  component: "LogisticRegressionCalculator",
  folder: "AdvancedMath",
  title: "Logistic Regression Calculator - Fit Logistic Models | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Logistic Regression Calculator to fit logistic regression models for binary classification problems.",
  keywords: "logistic regression calculator, classification models, statistical modeling, machine learning, advanced statistics, probability models"
},
{
  path: "/PowerRegressionCalculator",
  component: "PowerRegressionCalculator",
  folder: "AdvancedMath",
  title: "Power Regression Calculator - Fit Power Law Models | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Power Regression Calculator to fit power law models (y = ax^b) to data and analyze power relationships.",
  keywords: "power regression calculator, power law models, curve fitting, advanced statistics, mathematical modeling, data analysis"
},
{
  path: "/PiecewiseFunctionPlotter",
  component: "PiecewiseFunctionPlotter",
  folder: "AdvancedMath",
  title: "Piecewise Function Plotter - Plot Piecewise Functions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Piecewise Function Plotter to visualize piecewise-defined functions with multiple domains and definitions.",
  keywords: "piecewise function plotter, mathematical graphing, function visualization, advanced mathematics, graphing tool, mathematical functions"
},
{
  path: "/ParametricGraphPlotter",
  component: "ParametricGraphPlotter",
  folder: "AdvancedMath",
  title: "Parametric Graph Plotter - Plot Parametric Equations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Parametric Graph Plotter to visualize parametric equations and curves defined by parameter t.",
  keywords: "parametric graph plotter, parametric equations, curve plotting, advanced mathematics, graphing tool, mathematical visualization"
},
{
  path: "/PolarGraphPlotter",
  component: "PolarGraphPlotter",
  folder: "AdvancedMath",
  title: "Polar Graph Plotter - Plot Polar Equations | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Polar Graph Plotter to visualize polar equations and curves in polar coordinate system.",
  keywords: "polar graph plotter, polar coordinates, polar equations, advanced mathematics, graphing tool, mathematical visualization"
},
{
  path: "/3DSurfacePlotter",
  component: "3DSurfacePlotter",
  folder: "AdvancedMath",
  title: "3D Surface Plotter - Plot 3D Functions | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's 3D Surface Plotter to visualize three-dimensional functions and surfaces with interactive 3D plotting.",
  keywords: "3D surface plotter, three-dimensional graphing, 3D functions, advanced mathematics, visualization tool, mathematical graphics"
},
{
  path: "/ResidualPlotGenerator",
  component: "ResidualPlotGenerator",
  folder: "AdvancedMath",
  title: "Residual Plot Generator - Create Residual Plots | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Residual Plot Generator to create residual plots for regression analysis and model diagnostics.",
  keywords: "residual plot generator, regression diagnostics, statistical plots, data analysis, advanced statistics, model evaluation"
},
{
  path: "/BestFitCurveFinder",
  component: "BestFitCurveFinder",
  folder: "AdvancedMath",
  title: "Best Fit Curve Finder - Find Optimal Curve Fits | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Best Fit Curve Finder to determine optimal curve fits for data using various mathematical models.",
  keywords: "best fit curve finder, curve fitting, mathematical modeling, data analysis, advanced statistics, optimization"
},
{
  path: "/ScatterPlotGenerator",
  component: "ScatterPlotGenerator",
  folder: "AdvancedMath",
  title: "Scatter Plot Generator - Create Scatter Plots | Tools.D-TechStudios.com",
  description: "Use Tools.D-TechStudios.com's Scatter Plot Generator to create scatter plots for data visualization and correlation analysis.",
  keywords: "scatter plot generator, data visualization, statistical plots, correlation analysis, advanced statistics, data graphing"
},
];

// NOTE: You have 300+ routes total. For brevity, I've shown patterns for each category.
// You need to add ALL your remaining routes following the same pattern.
// Each route should have: path, component, title, description, keywords

// Helper function to get route by path
export const getRouteByPath = (path) => {
  return calculatorRoutes.find(route => route.path === path);
};

// Helper function to get all paths
export const getAllPaths = () => {
  return calculatorRoutes.map(route => route.path);
};